(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["bsk-collection-grid"] && !Shopify.designMode) return;
  try {
    
  (function () {
    const init = (scope) => {
      const root = (scope || document).querySelector('[data-bsk-collection]');
      if (!root || root.dataset.bskInit) return;
      root.dataset.bskInit = 'true';

      /* ---------- Sıralama: değişince gönder ---------- */
      const sortForm = root.querySelector('[data-sort-form]');
      const sortSelect = root.querySelector('[data-sort-select]');
      if (sortForm && sortSelect) {
        sortSelect.addEventListener('change', () => sortForm.submit());
      }

      /* ---------- Yoğunluk değiştirici ---------- */
      const densityBtns = root.querySelectorAll('[data-density]');
      const applyDensity = (mode) => {
        root.classList.toggle('is-wide', mode === 'wide');
        densityBtns.forEach((b) => b.classList.toggle('is-active', b.dataset.density === mode));
        try { window.localStorage.setItem('bskDensity', mode); } catch (e) {}
      };

      let saved = 'compact';
      try { saved = window.localStorage.getItem('bskDensity') || 'compact'; } catch (e) {}
      applyDensity(saved);

      densityBtns.forEach((btn) => {
        btn.addEventListener('click', () => applyDensity(btn.dataset.density));
      });

      /* ---------- Filtre paneli ---------- */
      const drawer = root.querySelector('[data-filter-drawer]');
      const openBtn = root.querySelector('[data-filter-open]');

      if (drawer && openBtn) {
        /* Panel body'ye taşınıyor: tema sarmalayıcıları
           position:fixed konumunu kırpabiliyor. */
        if (drawer.parentElement !== document.body) {
          document.body.appendChild(drawer);
        }

        const lock = () => {
          document.documentElement.classList.add('bsk-no-scroll');
          document.body.classList.add('bsk-no-scroll');
        };
        const unlock = () => {
          document.documentElement.classList.remove('bsk-no-scroll');
          document.body.classList.remove('bsk-no-scroll');
        };

        const open = () => {
          drawer.hidden = false;
          lock();
          window.requestAnimationFrame(() => drawer.classList.add('is-open'));
          openBtn.setAttribute('aria-expanded', 'true');
          const close = drawer.querySelector('.bsk-col__drawer-close');
          if (close) close.focus();
        };

        const close = () => {
          drawer.classList.remove('is-open');
          unlock();
          openBtn.setAttribute('aria-expanded', 'false');
          openBtn.focus();
          window.setTimeout(() => { drawer.hidden = true; }, 300);
        };

        openBtn.addEventListener('click', open);
        drawer.querySelectorAll('[data-filter-close]').forEach((el) => {
          el.addEventListener('click', close);
        });
        drawer.addEventListener('keydown', (event) => {
          if (event.key === 'Escape') close();
        });

        /* Facet akordiyonları */
        drawer.querySelectorAll('[data-facet-toggle]').forEach((btn) => {
          btn.addEventListener('click', () => {
            const body = btn.parentElement.querySelector('[data-facet-body]');
            const isOpen = btn.getAttribute('aria-expanded') === 'true';
            btn.setAttribute('aria-expanded', isOpen ? 'false' : 'true');
            if (body) body.classList.toggle('is-open', !isOpen);
          });
        });

        /* Formu gönderirken boş alanları at, temiz URL kalsın */
        const form = drawer.querySelector('[data-filter-form]');
        if (form) {
          form.addEventListener('submit', (event) => {
            event.preventDefault();
            const data = new FormData(form);
            const params = new URLSearchParams();
            data.forEach((value, key) => {
              if (String(value).trim() !== '') params.append(key, value);
            });
            const base = window.location.pathname;
            window.location.href = params.toString() ? base + '?' + params.toString() : base;
          });
        }
      }

      /* ---------- Judge.me rozeti ----------
         Sadece "Judge.me rozeti" görünümünde iş yapar. Rozeti sayfa
         açılışında Judge.me'nin betiği görünür yapar; "Daha fazla göster"
         ile sonradan eklenen kartlarda bu adım kaçabildiği için yorumu
         olan rozetler burada görünür yapılır. */
      const revealJudgemeBadges = (nodes) => {
        nodes.forEach((node) => {
          if (!node.querySelectorAll) return;
          node.querySelectorAll('.jdgm-prev-badge').forEach((badge) => {
            const count = parseInt(badge.getAttribute('data-number-of-reviews') || '0', 10);
            if (count > 0 && badge.style.display === 'none') badge.style.display = '';
          });
        });
      };

      /* ---------- Daha fazla göster ---------- */
      const moreBtn = root.querySelector('[data-load-more]');
      const grid = root.querySelector('[data-grid]');
      const progress = root.querySelector('[data-progress]');

      if (moreBtn && grid) {
        moreBtn.addEventListener('click', async () => {
          const next = moreBtn.dataset.nextUrl;
          if (!next) return;

          const label = moreBtn.textContent;
          moreBtn.disabled = true;
          moreBtn.textContent = 'Yükleniyor…';

          try {
            const sep = next.indexOf('?') > -1 ? '&' : '?';
            const url = next + sep + 'section_id=' + moreBtn.dataset.sectionId;
            const response = await fetch(url);
            if (!response.ok) throw new Error('fetch failed');

            const text = await response.text();
            const doc = new DOMParser().parseFromString(text, 'text/html');
            const newGrid = doc.querySelector('[data-grid]');
            const newBtn = doc.querySelector('[data-load-more]');
            const newProgress = doc.querySelector('[data-progress]');

            if (newGrid) {
              const added = Array.from(newGrid.children);
              added.forEach((li) => grid.appendChild(li));
              revealJudgemeBadges(added);
            }
            if (progress && newProgress) {
              progress.textContent = newProgress.textContent;
            }

            if (newBtn && newBtn.dataset.nextUrl) {
              moreBtn.dataset.nextUrl = newBtn.dataset.nextUrl;
              moreBtn.disabled = false;
              moreBtn.textContent = label;
            } else {
              moreBtn.remove();
            }
          } catch (e) {
            moreBtn.disabled = false;
            moreBtn.textContent = label;
          }
        });
      }
    };

    if (document.readyState !== 'loading') {
      init(document);
    } else {
      document.addEventListener('DOMContentLoaded', () => init(document));
    }
    document.addEventListener('shopify:section:load', (event) => init(event.target));
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["bsk-fullscreen-banner"] && !Shopify.designMode) return;
  try {
    
  /* Görünür değilken videoyu duraklat: sabitlenmiş paneller pil yakmasın.
     Gizlenen bölümlerdeki videolar hiç kesişmediği için oynamaya da başlamaz. */
  (function () {
    if (!('IntersectionObserver' in window)) return;

    const observe = () => {
      document.querySelectorAll('[data-panel-video]').forEach((video) => {
        if (video.dataset.bskObserved) return;
        video.dataset.bskObserved = 'true';

        const io = new IntersectionObserver((entries) => {
          entries.forEach((entry) => {
            if (entry.isIntersecting) {
              video.play().catch(() => {});
            } else {
              video.pause();
            }
          });
        }, { threshold: 0.1 });

        io.observe(video);
      });
    };

    if (document.readyState !== 'loading') {
      observe();
    } else {
      document.addEventListener('DOMContentLoaded', observe);
    }
    document.addEventListener('shopify:section:load', observe);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["bsk-header"] && !Shopify.designMode) return;
  try {
    
  if (!window.customElements.get('bsk-header')) {
    const FOCUSABLE = 'a[href], button:not([disabled]), input, select, textarea, [tabindex]:not([tabindex="-1"])';

    /* ---------- İŞ BİRLİĞİ YAZI TİPLERİ ----------
       Yalnızca menüdeki iş birliği rozetlerinde kullanılıyor. Harici
       istek yok: A-Z, Türkçe büyük harfler ve rakamlardan oluşan alt
       kümeler (WOFF2) burada gömülü. Bu dosya ertelenmiş yüklendiği ve
       menü zaten JS ile açıldığı için sayfa açılışına yük bindirmiyor.

       Lisans: SIL Open Font License 1.1 (https://openfontlicense.org).
       OFL gereği değiştirilmiş (alt küme) sürümler özgün adla
       dağıtılamadığından "BSK Collab ..." adıyla yeniden adlandırıldı;
       telif ve lisans kayıtları dosyaların içinde duruyor.
       - Sedgwick Ave Display © 2017 The Sedgwick Ave Project Authors
       - Montserrat Bold © 2011 The Montserrat Project Authors
       - Righteous © 2011 Brian J. Bonislawsky DBA Astigmatic (AOETI) */
    const BSK_COLLAB_FONTS = [
      {
        family: 'BSK Collab Manifest',
        weight: '400',
        data: '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'
      },
      {
        family: 'BSK Collab Jejumei',
        weight: '700',
        data: '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'
      },
      {
        family: 'BSK Collab Yoyoso',
        weight: '400',
        data: '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'
      }
    ];

    let bskCollabFontsLoaded = false;

    const loadCollabFonts = () => {
      if (bskCollabFontsLoaded || !('FontFace' in window) || !document.fonts) return;
      bskCollabFontsLoaded = true;

      BSK_COLLAB_FONTS.forEach((font) => {
        try {
          const raw = window.atob(font.data);
          const bytes = new Uint8Array(raw.length);
          for (let i = 0; i < raw.length; i += 1) bytes[i] = raw.charCodeAt(i);
          const face = new FontFace(font.family, bytes.buffer, { weight: font.weight });
          document.fonts.add(face);
          face.load().catch(() => { /* yedek yazı tipine düşer */ });
        } catch (e) { /* yedek yazı tipine düşer */ }
      });
    };

    class BskHeader extends HTMLElement {
      connectedCallback() {
        this.bar = this.querySelector('.bsk-header__bar');
        this.drawer = this.querySelector('[data-drawer]');
        this.search = this.querySelector('[data-search]');
        this.lastScroll = window.scrollY;
        this.panelStack = ['root'];
        this.overlay = this.dataset.overlay === 'true';
        this.hosts = [];

        this.neutralizeHosts();
        this.initScroll();
        this.initDrawer();
        this.initCollabs();
        this.initSearch();
        this.initCart();
        this.initLocalization();
        this.initEscape();

        /* Bar taşınırken içindeki düğmelere ait referansların hazır
           olması gerekiyor, o yüzden tüm init'lerden SONRA çağrılıyor.
           Taşıma düğmelerin dinleyicilerini bozmaz, düğüm taşınırken
           kendi dinleyicileriyle birlikte gider. */
        this.portalBar();
        this.syncHeight();

        this.resizeObserver = new ResizeObserver(() => {
          this.syncHeight();
          this.measureSolidPoint();
        });
        if (this.bar) this.resizeObserver.observe(this.bar);

        window.addEventListener('resize', () => this.measureSolidPoint());
        window.addEventListener('load', () => this.measureSolidPoint());

        this.portalOverlays();
      }

      /* Menü ve arama katmanını body'ye taşı.
         Temanın header sarmalayıcısında transform/overflow varsa
         position:fixed o sarmalayıcıya göre konumlanıp kırpılıyor.
         Body'ye taşıyınca hiçbir sarmalayıcı etkilemiyor. */
      portalOverlays() {
        [this.drawer, this.search].forEach((el) => {
          if (el && el.parentElement !== document.body) {
            el.dataset.bskPortaled = 'true';
            document.body.appendChild(el);
          }
        });
      }

      /* ---------- GÜVENLİK AĞI ----------
         Bindirme, temanın DOM yapısına bağlı olarak beklenmedik
         şekilde bozulabiliyor: sarmalayıcıda transform varsa fixed
         kırpılıyor, içerik sarmalayıcısı yüksek z-index ile kendi
         yığın bağlamını kurarsa header arkada kalıyor.

         Burada gerçekten görünüyor mu diye isabet testi yapıyoruz:
         barın ortasındaki noktada hangi eleman var? Bar değilse
         header görünmüyor demektir ve bindirmeden vazgeçip normal
         opak header'a dönüyoruz. Görünmeyen header'dan iyidir. */
      verifyBar() {
        if (!this.overlay || !this.bar) return;
        if (this.drawerOpen || this.searchOpen) return;
        if (this.classList.contains('is-hidden')) return;
        if (window.scrollY > 10) return;

        const rect = this.bar.getBoundingClientRect();
        if (rect.width < 4 || rect.height < 4) { this.disableOverlay(); return; }

        const cs = window.getComputedStyle(this.bar);
        if (cs.display === 'none' || cs.visibility === 'hidden' || parseFloat(cs.opacity) < 0.05) {
          this.disableOverlay();
          return;
        }

        const x = Math.round(rect.left + rect.width / 2);
        const y = Math.round(rect.top + rect.height / 2);
        const at = document.elementFromPoint(x, y);
        const hit = at && (at === this.bar || this.bar.contains(at) || at.contains(this.bar));

        if (!hit) this.disableOverlay();
      }

      disableOverlay() {
        if (!this.overlay) return;
        this.overlay = false;
        this.dataset.overlay = 'false';
        this.dataset.overlayFallback = 'true';

        /* Barı kendi yerine geri koy */
        if (this.bar && this.bar.parentElement !== this) {
          this.insertBefore(this.bar, this.firstChild);
        }
        if (this.fixedHost && this.fixedHost.parentElement === document.body) {
          this.fixedHost.remove();
        }
        this.fixedHost = null;

        this.classList.remove(
          'bsk-header--portaled',
          'bsk-header--overlay',
          'bsk-header--ov-glass',
          'bsk-header--ov-plain',
          'bsk-header--invert-logo',
          'is-solid'
        );

        /* Sarmalayıcıların sıfırlamasını geri al, header yer kaplasın */
        this.restoreHosts();
        this.syncHeight();
        document.dispatchEvent(new CustomEvent('bsk:layout'));
      }

      /* ---------- Bindirme: üst barı body'ye taşı ----------
         Temanın header sarmalayıcısı position:fixed'i kırptığı için
         (menü ve arama katmanlarında da aynı sorun var, onlar da
         taşınıyor) bindirmede barı doğrudan body'ye alıyoruz.
         Ayar değişkenleri inline style ile, durum sınıfları da
         kopyalanarak taşınıyor ki CSS kuralları bozulmasın. */
      portalBar() {
        if (!this.overlay || !this.bar) return;

        let host = document.querySelector('[data-bsk-header-fixed]');
        if (!host) {
          host = document.createElement('div');
          host.setAttribute('data-bsk-header-fixed', '');
          document.body.appendChild(host);
        }

        /* Sınıflar kopyalanıyor: .bsk-header--ov-glass gibi kurallar
           bar'a ancak üstündeki kaptan inebiliyor. */
        host.className = this.className + ' bsk-header__fixed';

        const inline = this.getAttribute('style');
        if (inline) host.setAttribute('style', inline);

        host.appendChild(this.bar);
        this.fixedHost = host;
        this.classList.add('bsk-header--portaled');

        /* Yerleşim değişti; ürün bölümü görseli yeniden ölçsün */
        window.requestAnimationFrame(() => {
          document.dispatchEvent(new CustomEvent('bsk:layout'));

          /* Bir kare sonra gerçekten görünüyor mu diye bak */
          window.requestAnimationFrame(() => this.verifyBar());
        });

        /* Geç yüklenen tema betikleri yerleşimi bozabiliyor,
           yükleme bitince ve kısa bir gecikmeyle tekrar bak. */
        window.addEventListener('load', () => this.verifyBar());
        window.setTimeout(() => this.verifyBar(), 900);
      }

      /* Durum sınıfları hem özel elemana hem taşınan kaba yazılıyor */
      setState(name, on) {
        this.classList.toggle(name, on);
        if (this.fixedHost) this.fixedHost.classList.toggle(name, on);
      }

      /* ---------- Bindirme: sarmalayıcıları sıfırla ----------
         Header position:fixed olunca akıştan çıkıyor ama temanın
         sarmalayıcısı dolgu veya sabit yükseklik taşıyorsa sayfa
         yine yukarıdan boşluk bırakıyor. Sadece header'ın TEK çocuk
         olduğu sarmalayıcılara dokunuyoruz; aynı grupta duyuru
         çubuğu gibi başka bölüm varsa orada duruyoruz. */
      neutralizeHosts() {
        if (!this.overlay) return;

        let node = this.parentElement;
        while (node && node !== document.body) {
          if (node.children.length > 1) break;
          node.classList.add('bsk-header__host');
          this.hosts.push(node);
          node = node.parentElement;
        }

        /* Ürün bölümü galeri yüksekliğini yeniden ölçsün */
        window.requestAnimationFrame(() => {
          document.dispatchEvent(new CustomEvent('bsk:layout'));
        });
      }

      restoreHosts() {
        this.hosts.forEach((node) => node.classList.remove('bsk-header__host'));
        this.hosts = [];
      }

      disconnectedCallback() {
        if (this.resizeObserver) this.resizeObserver.disconnect();
        if (this.onDocKeydown) document.removeEventListener('keydown', this.onDocKeydown);
        this.unlockScroll();
        this.restoreHosts();

        /* Taşınan bar kabı geride kalmasın, yoksa tema düzenleyicide
           her kaydetmede ekranda ikinci bir header birikiyor. */
        if (this.fixedHost && this.fixedHost.parentElement === document.body) {
          this.fixedHost.remove();
          this.fixedHost = null;
        }

        /* Tema düzenleyici bölümü yeniden bastığında kopya kalmasın */
        [this.drawer, this.search].forEach((el) => {
          if (el && el.dataset.bskPortaled === 'true' && el.parentElement === document.body) {
            el.remove();
          }
        });
      }

      /* Diğer bölümlerin kullanabilmesi için header yüksekliğini yay.
         --bsk-header-height : barın gerçek yüksekliği
         --bsk-header-overlay-h : yalnızca bindirmede barın yüksekliği,
           akıştaysa 0. Ürün sayfası breadcrumb'ı bunu kullanıyor. */
      syncHeight() {
        if (!this.bar) return;
        const h = this.bar.offsetHeight;
        const root = document.documentElement.style;
        root.setProperty('--bsk-header-height', h + 'px');
        root.setProperty('--bsk-header-overlay-h', this.overlay ? h + 'px' : '0px');
      }

      /* Bindirmede header'ın opaklaşacağı kaydırma noktası.
         Ürün bölümü galerisine [data-bsk-overlay-anchor] koyuluyor;
         yoksa ekranın %60'ı kullanılıyor. */
      measureSolidPoint() {
        if (!this.overlay) return;
        const anchor = document.querySelector('[data-bsk-overlay-anchor]');
        const barH = this.bar ? this.bar.offsetHeight : 56;
        const area = anchor ? anchor.offsetHeight : Math.round(window.innerHeight * 0.6);
        this.solidAt = Math.max(40, area - barH);
      }

      /* ---------- Kaydırma davranışı ---------- */
      initScroll() {
        const hideOnScroll = this.dataset.hideOnScroll === 'true';
        let queued = false;

        this.measureSolidPoint();

        const onScroll = () => {
          if (queued) return;
          queued = true;
          window.requestAnimationFrame(() => {
            const y = window.scrollY;
            this.setState('is-scrolled', y > 8);

            if (this.overlay) {
              this.setState('is-solid', y >= (this.solidAt || 0));
            }

            if (hideOnScroll && !this.drawerOpen && !this.searchOpen) {
              const goingDown = y > this.lastScroll && y > 140;
              this.setState('is-hidden', goingDown);
            }
            this.lastScroll = y;
            queued = false;
          });
        };

        window.addEventListener('scroll', onScroll, { passive: true });
        onScroll();
      }

      /* ---------- Escape ----------
         Belge düzeyinde dinleniyor ki odak katmanın dışına düşse bile
         (ör. panelde boş bir yere tıklanınca) açık katman kapansın.
         Tema düzenleyicide bölüm yeniden basılınca dinleyici
         disconnectedCallback'te kaldırılıyor, birikmiyor. */
      initEscape() {
        this.onDocKeydown = (event) => {
          if (event.key !== 'Escape') return;
          if (this.searchOpen) {
            this.closeSearch();
          } else if (this.drawerOpen) {
            this.closeDrawer();
          }
        };
        document.addEventListener('keydown', this.onDocKeydown);
      }

      /* ---------- Kaydırma kilidi ---------- */
      lockScroll() {
        this.scrollY = window.scrollY;
        document.documentElement.classList.add('bsk-no-scroll');
        document.body.classList.add('bsk-no-scroll');
      }

      unlockScroll() {
        document.documentElement.classList.remove('bsk-no-scroll');
        document.body.classList.remove('bsk-no-scroll');
      }

      trapFocus(container, event) {
        const nodes = Array.from(container.querySelectorAll(FOCUSABLE))
          .filter((el) => el.offsetParent !== null);
        if (nodes.length === 0) return;
        const first = nodes[0];
        const last = nodes[nodes.length - 1];

        if (event.shiftKey && document.activeElement === first) {
          event.preventDefault();
          last.focus();
        } else if (!event.shiftKey && document.activeElement === last) {
          event.preventDefault();
          first.focus();
        }
      }

      /* ---------- MENÜ ---------- */
      initDrawer() {
        if (!this.drawer) return;

        this.menuButton = this.querySelector('[data-menu-open]');
        this.dialog = this.drawer.querySelector('.bsk-drawer__dialog');
        this.backBtn = this.drawer.querySelector('[data-drawer-back]');
        this.titleEl = this.drawer.querySelector('[data-drawer-title]');
        this.panels = Array.from(this.drawer.querySelectorAll('[data-panel]'));
        this.rootTitle = this.titleEl ? this.titleEl.textContent : '';

        if (this.menuButton) {
          this.menuButton.addEventListener('click', () => this.openDrawer());
        }

        this.drawer.querySelectorAll('[data-drawer-close]').forEach((el) => {
          el.addEventListener('click', () => this.closeDrawer());
        });

        if (this.backBtn) {
          this.backBtn.addEventListener('click', () => this.popPanel());
        }

        this.drawer.querySelectorAll('[data-panel-open]').forEach((btn) => {
          btn.addEventListener('click', () => this.pushPanel(btn.dataset.panelOpen));
        });

        /* Escape belge düzeyinde dinleniyor (initEscape); burada
           yalnızca odak tuzağı kalıyor. */
        this.drawer.addEventListener('keydown', (event) => {
          if (event.key === 'Tab') this.trapFocus(this.dialog, event);
        });
      }

      openDrawer() {
        this.drawerOpen = true;
        this.setState('is-hidden', false);
        this.drawer.hidden = false;
        this.lockScroll();
        window.requestAnimationFrame(() => this.drawer.classList.add('is-open'));
        if (this.menuButton) this.menuButton.setAttribute('aria-expanded', 'true');

        const target = this.drawer.querySelector('.bsk-drawer__close');
        if (target) target.focus();
      }

      closeDrawer() {
        this.drawerOpen = false;
        this.drawer.classList.remove('is-open');
        this.unlockScroll();
        if (this.menuButton) {
          this.menuButton.setAttribute('aria-expanded', 'false');
          this.menuButton.focus();
        }
        window.setTimeout(() => {
          if (!this.drawerOpen) {
            this.drawer.hidden = true;
            this.resetPanels();
          }
        }, 320);
      }

      pushPanel(id) {
        const panel = this.panels.find((p) => p.dataset.panel === id);
        if (!panel) return;

        const current = this.panels.find((p) => p.dataset.panel === this.panelStack[this.panelStack.length - 1]);
        if (current) {
          current.classList.remove('is-active');
          current.classList.add('is-behind');
        }

        panel.classList.add('is-active');
        this.panelStack.push(id);
        this.updateDrawerHead();
        panel.scrollTop = 0;

        const firstRow = panel.querySelector('.bsk-drawer__row');
        if (firstRow) firstRow.focus({ preventScroll: true });
      }

      popPanel() {
        if (this.panelStack.length < 2) return;
        const leavingId = this.panelStack.pop();
        const leaving = this.panels.find((p) => p.dataset.panel === leavingId);
        if (leaving) leaving.classList.remove('is-active');

        const target = this.panels.find((p) => p.dataset.panel === this.panelStack[this.panelStack.length - 1]);
        if (target) {
          target.classList.remove('is-behind');
          target.classList.add('is-active');
        }
        this.updateDrawerHead();

        /* Odak, kapanan paneli açan satıra döner. Eskiden ana menüye
           dönülünce odaktaki "Geri" düğmesi gizleniyor, odak sayfaya
           düşüyor ve Escape menüyü kapatmıyordu. */
        const opener = target && target.querySelector('[data-panel-open="' + leavingId + '"]');
        if (opener) {
          opener.focus({ preventScroll: true });
        } else if (this.backBtn && this.panelStack.length > 1) {
          this.backBtn.focus();
        }
      }

      resetPanels() {
        this.panelStack = ['root'];
        this.panels.forEach((p) => {
          p.classList.remove('is-behind');
          p.classList.toggle('is-active', p.dataset.panel === 'root');
        });
        this.updateDrawerHead();
      }

      updateDrawerHead() {
        const currentId = this.panelStack[this.panelStack.length - 1];
        const current = this.panels.find((p) => p.dataset.panel === currentId);
        if (this.titleEl) {
          this.titleEl.textContent = current ? current.dataset.panelTitle : this.rootTitle;
        }
        if (this.backBtn) this.backBtn.hidden = this.panelStack.length < 2;
      }

      /* ---------- İŞ BİRLİĞİ SATIRLARI ----------
         Başlığında ayarlardaki kelime geçen satırlar iş ortağının
         kimliğiyle gösterilir: "Manifest X Ecrou" → [MANIFEST] X Ecrou.
         Yalnızca ortağın adı rozet olur, "X Ecrou" olduğu gibi kalır.

         Aynı mantığı Liquid'de üç menü seviyesi için ayrı ayrı yazmamak
         için burada, tek yerde yapılıyor. Menü zaten JS ile açıldığından
         JS'siz durumda kaybedilen bir şey yok; satırlar düz yazı kalır. */
      initCollabs() {
        if (!this.drawer || this.drawer.dataset.collabs !== 'true') return;

        const rules = ['lulu', 'jejumei', 'yoyoso', 'manifest']
          .map((brand) => ({
            brand,
            key: (this.drawer.getAttribute('data-collab-' + brand) || '').trim().toLowerCase()
          }))
          .filter((rule) => rule.key !== '');
        if (rules.length === 0) return;

        loadCollabFonts();

        const piece = (className, text) => {
          const el = document.createElement('span');
          el.className = className;
          el.textContent = text;
          return el;
        };

        let order = 0;

        this.drawer.querySelectorAll('.bsk-drawer__row:not(.bsk-drawer__row--all)').forEach((row) => {
          const label = row.querySelector('span');
          if (!label || row.classList.contains('bsk-drawer__row--collab')) return;

          const title = label.textContent.trim();
          const rule = rules.find((r) => title.toLowerCase().indexOf(r.key) !== -1);
          if (!rule) return;

          /* "Ortak X Ecrou" → [ortak] + "X Ecrou". Ters yazılmışsa
             ("Ecrou X Ortak") rozet sağdaki ada gelir. Küçük x ve ×
             de ayraç sayılır; ayraç yoksa başlığın tamamı rozet olur. */
          let head = '';
          let partner = title;
          let tail = '';
          const parts = title.match(/^(.+?)(\s+[x×]\s+)(.+)$/i);
          if (parts) {
            if (parts[1].toLowerCase().indexOf(rule.key) !== -1) {
              partner = parts[1];
              tail = (parts[2] + parts[3]).trim();
            } else if (parts[3].toLowerCase().indexOf(rule.key) !== -1) {
              head = (parts[1] + parts[2]).trim();
              partner = parts[3];
            }
          }

          const wrap = document.createElement('span');
          wrap.className = 'bsk-collab bsk-collab--' + rule.brand;

          const badge = piece('bsk-collab__brand', partner);
          /* Büyük harfe çevirirken Türkçe kuralı (i → İ) devreye girmesin:
             "Manifest" → "MANİFEST" değil "MANIFEST" olsun. */
          badge.lang = 'en';
          badge.style.setProperty('--bsk-collab-i', String(order));
          order += 1;

          /* Parçalar arasındaki boşluklar flex düzeninde görünmüyor ama
             ekran okuyucu "Manifest X Ecrou" diye okusun diye gerekli;
             yoksa "ManifestX Ecrou" oluyor. */
          if (head) wrap.append(piece('bsk-collab__rest', head), ' ');
          wrap.appendChild(badge);
          if (tail) wrap.append(' ', piece('bsk-collab__rest', tail));

          label.textContent = '';
          label.appendChild(wrap);
          row.classList.add('bsk-drawer__row--collab');
        });
      }

      /* ---------- ARAMA ---------- */
      initSearch() {
        if (!this.search) return;

        this.searchButton = this.querySelector('[data-search-open]');
        this.input = this.search.querySelector('[data-search-input]');
        this.results = this.search.querySelector('[data-search-results]');
        this.popular = this.search.querySelector('[data-search-popular]');

        if (this.searchButton) {
          this.searchButton.addEventListener('click', () => this.openSearch());
        }

        this.search.querySelectorAll('[data-search-close]').forEach((el) => {
          el.addEventListener('click', () => this.closeSearch());
        });

        this.search.addEventListener('keydown', (event) => {
          if (event.key === 'Tab') this.trapFocus(this.search, event);
        });

        let debounce;
        if (this.input) {
          this.input.addEventListener('input', () => {
            window.clearTimeout(debounce);
            const q = this.input.value.trim();
            if (q.length < 2) {
              this.results.innerHTML = '';
              if (this.popular) this.popular.hidden = false;
              return;
            }
            debounce = window.setTimeout(() => this.fetchSuggestions(q), 260);
          });
        }
      }

      openSearch() {
        this.searchOpen = true;
        this.setState('is-hidden', false);
        this.search.hidden = false;
        this.lockScroll();
        window.requestAnimationFrame(() => this.search.classList.add('is-open'));
        if (this.searchButton) this.searchButton.setAttribute('aria-expanded', 'true');
        if (this.input) this.input.focus();
      }

      closeSearch() {
        this.searchOpen = false;
        this.search.classList.remove('is-open');
        this.unlockScroll();
        if (this.searchButton) {
          this.searchButton.setAttribute('aria-expanded', 'false');
          this.searchButton.focus();
        }
        window.setTimeout(() => {
          if (!this.searchOpen) this.search.hidden = true;
        }, 220);
      }

      /* Ürün bölümüyle aynı TR biçimi: 2.690,00 TL */
      formatMoney(raw) {
        const cents = this.toCents(raw);
        if (cents === null) return '';
        if (typeof window.bskMoney === 'function') {
          return window.bskMoney(cents, 'TL');
        }
        try {
          return new Intl.NumberFormat('tr-TR', {
            minimumFractionDigits: 2,
            maximumFractionDigits: 2
          }).format(cents / 100) + ' TL';
        } catch (e) {
          return (cents / 100).toFixed(2) + ' TL';
        }
      }

      /* Tahminli arama fiyatı bazı sürümlerde kuruş sayısı, bazılarında
         "1123.75" gibi metin geliyor. İkisini de kuruşa çeviriyoruz. */
      toCents(raw) {
        if (raw === null || raw === undefined || raw === '') return null;
        if (typeof raw === 'number') return Math.round(raw);

        const s = String(raw).trim();
        if (/^\d+$/.test(s)) return parseInt(s, 10);

        const cleaned = s
          .replace(/[^\d.,]/g, '')
          .replace(/\.(?=\d{3}(\D|$))/g, '')
          .replace(',', '.');
        const num = parseFloat(cleaned);
        return isNaN(num) ? null : Math.round(num * 100);
      }

      esc(value) {
        return String(value === null || value === undefined ? '' : value)
          .replace(/&/g, '&amp;')
          .replace(/</g, '&lt;')
          .replace(/>/g, '&gt;')
          .replace(/"/g, '&quot;')
          .replace(/'/g, '&#39;');
      }

      /* Shopify görsel URL'lerine boyut eklerken mevcut sorguyu koru */
      imgUrl(url, width) {
        if (!url) return '';
        return url + (url.indexOf('?') === -1 ? '?' : '&') + 'width=' + width;
      }

      async fetchSuggestions(query) {
        /* Shopify tahminli arama uç noktası .json ile çağrılmak zorunda.
           Eski kod bu eki hiç eklemiyordu, uç nokta HTML dönüyordu ve
           response.json() hata veriyordu. */
        let url = this.dataset.predictiveUrl || '/search/suggest';
        if (url.indexOf('.json') === -1) url += '.json';

        const params = new URLSearchParams();
        params.set('q', query);
        params.set('resources[type]', 'query,product,collection');
        params.set('resources[limit]', '6');
        params.set('resources[options][unavailable_products]', 'last');
        params.set('resources[options][fields]', 'title,product_type,variants.title,vendor,tag');

        try {
          const response = await fetch(url + '?' + params.toString(), {
            headers: { 'Accept': 'application/json' }
          });
          if (!response.ok) throw new Error('HTTP ' + response.status);
          const data = await response.json();
          this.renderSuggestions(data, query);
        } catch (e) {
          this.results.innerHTML =
            '<p class="bsk-search__empty">Arama sonuçları yüklenemedi. ' +
            'Enter\'a basarak arayabilirsin.</p>';
        }
      }

      renderSuggestions(data, query) {
        const found = (data.resources && data.resources.results) || {};
        const products = found.products || [];
        const queries = found.queries || [];
        const collections = found.collections || [];

        if (this.popular) this.popular.hidden = true;

        if (products.length === 0 && queries.length === 0 && collections.length === 0) {
          this.results.innerHTML =
            '<p class="bsk-search__empty">“' + this.esc(query) + '” için sonuç bulunamadı.</p>';
          return;
        }

        let html = '';

        /* Yazı önerileri — Shopify'ın kendi arama alanındaki gibi */
        if (queries.length > 0) {
          html += '<p class="bsk-search__label">Öneriler</p><ul class="bsk-search__terms">';
          html += queries.map((item) =>
            '<li><a href="' + this.esc(item.url) + '">' +
              '<svg viewBox="0 0 24 24" width="15" height="15" fill="none" aria-hidden="true">' +
                '<circle cx="11" cy="11" r="6.6" stroke="currentColor" stroke-width="1.5"/>' +
                '<path d="M16 16l4.5 4.5" stroke="currentColor" stroke-width="1.5" stroke-linecap="round"/>' +
              '</svg>' +
              '<span>' + this.esc(item.text) + '</span>' +
            '</a></li>'
          ).join('');
          html += '</ul>';
        }

        /* Koleksiyonlar */
        if (collections.length > 0) {
          html += '<p class="bsk-search__label">Kategoriler</p><ul class="bsk-search__terms">';
          html += collections.map((item) =>
            '<li><a href="' + this.esc(item.url) + '">' +
              '<span>' + this.esc(item.title) + '</span>' +
            '</a></li>'
          ).join('');
          html += '</ul>';
        }

        /* Ürünler */
        if (products.length > 0) {
          html += '<p class="bsk-search__label">Ürünler</p><ul class="bsk-search__grid">';
          html += products.map((product) => {
            const src = product.featured_image && product.featured_image.url
              ? product.featured_image.url
              : (product.image || '');
            const image = src
              ? '<img src="' + this.esc(this.imgUrl(src, 400)) + '" alt="" loading="lazy" decoding="async">'
              : '';

            const raw = (product.price !== undefined && product.price !== null)
              ? product.price
              : product.price_min;
            const price = this.formatMoney(raw);

            return '<li>' +
              '<a class="bsk-search__card" href="' + this.esc(product.url) + '">' +
                '<span class="bsk-search__card-media">' + image + '</span>' +
                '<span class="bsk-search__card-title">' + this.esc(product.title) + '</span>' +
                (price ? '<span class="bsk-search__card-price">' + price + '</span>' : '') +
              '</a>' +
            '</li>';
          }).join('');
          html += '</ul>';
        }

        const searchUrl = this.dataset.searchUrl || '/search';
        html += '<a class="bsk-search__all" href="' + searchUrl +
          '?q=' + encodeURIComponent(query) + '&type=product">Tüm sonuçları gör</a>';

        this.results.innerHTML = html;
      }

      /* ---------- SEPET SAYACI ---------- */
      initCart() {
        this.countEl = this.querySelector('[data-cart-count]');
        this.countText = this.querySelector('[data-cart-count-text]');
        if (!this.countEl) return;

        const refresh = () => this.refreshCart();
        ['cart:updated', 'cart:refresh', 'bsk:cart:refresh'].forEach((name) => {
          document.addEventListener(name, refresh);
        });
        window.addEventListener('pageshow', (event) => {
          if (event.persisted) refresh();
        });
      }

      async refreshCart() {
        try {
          const response = await fetch(window.Shopify && window.Shopify.routes
            ? window.Shopify.routes.root + 'cart.js'
            : '/cart.js');
          if (!response.ok) return;
          const cart = await response.json();
          this.countEl.textContent = cart.item_count;
          this.countEl.classList.toggle('is-empty', cart.item_count === 0);
          if (this.countText) this.countText.textContent = cart.item_count + ' ürün';
        } catch (e) { /* sessizce geç */ }
      }

      /* ---------- ÜLKE / DİL ---------- */
      initLocalization() {
        this.querySelectorAll('[data-loc-select]').forEach((select) => {
          select.addEventListener('change', () => {
            const form = select.closest('form');
            if (form) form.submit();
          });
        });
      }
    }

    window.customElements.define('bsk-header', BskHeader);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["bsk-hero-carousel"] && !Shopify.designMode) return;
  try {
    
  if (!window.customElements.get('bsk-hero-carousel')) {
    class BskHeroCarousel extends HTMLElement {
      constructor() {
        super();
        this.index = 0;
        this.timer = null;
        this.pointer = { active: false, startX: 0, deltaX: 0 };
      }

      connectedCallback() {
        this.track = this.querySelector('[data-track]');
        this.viewport = this.querySelector('[data-viewport]');
        this.slides = Array.from(this.querySelectorAll('[data-slide]'));
        this.bullets = Array.from(this.querySelectorAll('[data-bullet]'));
        this.live = this.querySelector('[data-live]');
        this.count = this.slides.length;

        if (!this.track || this.count === 0) return;

        this.reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
        this.autoplayEnabled = this.dataset.autoplay === 'true' && this.count > 1 && !this.reduceMotion;
        this.autoplaySpeed = parseInt(this.dataset.autoplaySpeed, 10) || 6000;

        this.bindEvents();
        this.goTo(0, { silent: true });
        this.startAutoplay();
      }

      disconnectedCallback() {
        this.stopAutoplay();
        if (this.io) this.io.disconnect();
      }

      bindEvents() {
        const prev = this.querySelector('[data-prev]');
        const next = this.querySelector('[data-next]');
        if (prev) prev.addEventListener('click', () => this.step(-1, true));
        if (next) next.addEventListener('click', () => this.step(1, true));

        this.bullets.forEach((bullet) => {
          bullet.addEventListener('click', () => {
            this.goTo(parseInt(bullet.dataset.index, 10));
            this.restartAutoplay();
          });
        });

        this.addEventListener('keydown', (event) => {
          if (event.key === 'ArrowLeft') { this.step(-1, true); }
          if (event.key === 'ArrowRight') { this.step(1, true); }
        });

        this.addEventListener('pointerenter', () => this.stopAutoplay());
        this.addEventListener('pointerleave', () => this.startAutoplay());
        this.addEventListener('focusin', () => this.stopAutoplay());
        this.addEventListener('focusout', () => this.startAutoplay());

        document.addEventListener('visibilitychange', () => {
          document.hidden ? this.stopAutoplay() : this.startAutoplay();
        });

        // Sadece görünürken oynat
        if ('IntersectionObserver' in window) {
          this.io = new IntersectionObserver((entries) => {
            entries.forEach((entry) => {
              entry.isIntersecting ? this.startAutoplay() : this.stopAutoplay();
            });
          }, { threshold: 0.25 });
          this.io.observe(this);
        }

        this.bindDrag();
      }

      bindDrag() {
        if (this.count < 2) return;
        const threshold = 45;

        this.viewport.addEventListener('pointerdown', (event) => {
          if (event.pointerType === 'mouse' && event.button !== 0) return;
          this.pointer.active = true;
          this.pointer.startX = event.clientX;
          this.pointer.deltaX = 0;
          this.track.classList.add('is-dragging');
          this.stopAutoplay();
        });

        this.viewport.addEventListener('pointermove', (event) => {
          if (!this.pointer.active) return;
          this.pointer.deltaX = event.clientX - this.pointer.startX;
          const width = this.viewport.clientWidth || 1;
          const offset = (this.pointer.deltaX / width) * 100;
          this.track.style.transform = 'translate3d(' + (-this.index * 100 + offset) + '%,0,0)';
        });

        const release = () => {
          if (!this.pointer.active) return;
          this.pointer.active = false;
          this.track.classList.remove('is-dragging');
          if (Math.abs(this.pointer.deltaX) > threshold) {
            this.step(this.pointer.deltaX < 0 ? 1 : -1, true);
          } else {
            this.goTo(this.index, { silent: true });
          }
          this.startAutoplay();
        };

        this.viewport.addEventListener('pointerup', release);
        this.viewport.addEventListener('pointercancel', release);
        this.viewport.addEventListener('pointerleave', release);

        // Sürükleme sonrası kazara tıklamayı engelle
        this.viewport.addEventListener('click', (event) => {
          if (Math.abs(this.pointer.deltaX) > 8) {
            event.preventDefault();
            event.stopPropagation();
          }
        }, true);
      }

      step(direction, restart) {
        const target = (this.index + direction + this.count) % this.count;
        this.goTo(target);
        if (restart) this.restartAutoplay();
      }

      goTo(index, options) {
        const opts = options || {};
        this.index = index;
        this.track.style.transform = 'translate3d(' + (-index * 100) + '%,0,0)';

        this.slides.forEach((slide, i) => {
          const isActive = i === index;
          slide.toggleAttribute('aria-hidden', !isActive);
          const link = slide.querySelector('[data-slide-link]');
          if (link) link.tabIndex = isActive ? 0 : -1;
          const video = slide.querySelector('video');
          if (video) {
            isActive ? video.play().catch(() => {}) : video.pause();
          }
        });

        this.bullets.forEach((bullet, i) => {
          const isActive = i === index;
          bullet.classList.toggle('is-active', isActive);
          bullet.setAttribute('aria-selected', isActive ? 'true' : 'false');
        });

        if (this.live && !opts.silent) {
          this.live.textContent = 'Slayt ' + (index + 1) + ' / ' + this.count;
        }
      }

      startAutoplay() {
        if (!this.autoplayEnabled || this.timer || this.pointer.active) return;
        this.timer = window.setInterval(() => this.step(1), this.autoplaySpeed);
      }

      stopAutoplay() {
        if (!this.timer) return;
        window.clearInterval(this.timer);
        this.timer = null;
      }

      restartAutoplay() {
        this.stopAutoplay();
        this.startAutoplay();
      }
    }

    window.customElements.define('bsk-hero-carousel', BskHeroCarousel);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["bsk-product"] && !Shopify.designMode) return;
  try {
    
  /* =================================================================
     TR fiyat biçimi — Liquid'deki bsk-money snippet'i ile birebir aynı
     269000 → "2.690,00 TL"
     Intl'e güvenmiyoruz, elle kuruyoruz ki sunucu ve tarayıcı
     çıktısı hiçbir cihazda ayrışmasın.
     ================================================================= */
  window.bskMoney = function (cents, suffix) {
    var v = Math.round(Number(cents) || 0);
    var neg = v < 0;
    v = Math.abs(v);

    var lira = Math.floor(v / 100);
    var kurus = v % 100;
    var dec = kurus < 10 ? '0' + kurus : String(kurus);

    var digits = String(lira);
    var out = '';
    var count = 0;
    for (var i = digits.length - 1; i >= 0; i--) {
      out = digits.charAt(i) + out;
      count++;
      if (count % 3 === 0 && i > 0) out = '.' + out;
    }

    var tail = suffix ? ' ' + suffix : '';
    return (neg ? '-' : '') + out + ',' + dec + tail;
  };

  /* ============ Varyant seçici + AJAX sepet ============
     <product-form-bsk> bölümün kök öğesi. Seçici, fiyat, ürün kodu ve
     sepete ekle ayrı bloklar olduğu için hepsini kökten buluyor; bloklar
     hangi sırada olursa olsun birlikte çalışıyorlar. */
  if (!window.customElements.get('product-form-bsk')) {
    class ProductFormBsk extends HTMLElement {
      connectedCallback() {
        const json = this.querySelector('[data-variants]');
        if (!json) return;

        try {
          this.variants = JSON.parse(json.textContent);
        } catch (e) {
          this.variants = [];
        }

        this.pdp = this.closest('[data-bsk-pdp]');
        this.moneySuffix = this.pdp ? (this.pdp.dataset.moneySuffix || '') : '';

        /* Stok bildirimi: tükenen beden seçilebilsin mi, seçilince
           butonun altında ne yazsın (ikisi de bölüm ayarı) */
        this.soldoutSelectable = !!this.pdp && this.pdp.dataset.soldoutSelectable === 'true';
        this.soldoutMsg = this.pdp ? (this.pdp.dataset.soldoutMsg || '') : '';
        this.msgSoldOut = false;
        this.sheetPick = false;
        this.lastVariantId = null;

        /* Öğe artık bütün bölümü (uygulama blokları dahil) sarıyor;
           yedek seçici yalnızca sepet formunu bulsun, bir uygulamanın
           formunu yakalamasın. */
        this.form = this.querySelector('[data-product-form]') || this.querySelector('form[action*="/cart/add"]');
        this.idInput = this.querySelector('[data-variant-id]');
        this.atc = this.querySelector('[data-atc]');
        this.atcLabel = this.querySelector('[data-atc-label]');
        this.msg = this.querySelector('[data-form-msg]');
        this.sheet = this.querySelector('[data-sheet]');

        this.priceEl = this.pdp.querySelector('[data-price]');
        this.compareEl = this.pdp.querySelector('[data-compare]');
        this.codeEls = this.pdp.querySelectorAll('[data-bsk-code]');
        this.codeWraps = this.pdp.querySelectorAll('[data-bsk-codes]');
        this.colorNameEl = this.pdp.querySelector('[data-color-name]');
        this.stickyPrice = this.pdp.querySelector('[data-sticky-price]');
        this.stickyLabel = this.pdp.querySelector('[data-sticky-label]');
        this.mediaList = this.pdp.querySelector('[data-media-list]');

        /* Başlangıç seçimi: sayfanın açıldığı varyant. Renk ve beden
           seçici bloğu kaldırılmış ya da gizlenmiş olsa da doğru varyantla
           başlansın diye önce ondan alınıyor; seçici varsa butonlar zaten
           aynı değerleri gösteriyor. */
        const start = this.variants.find((v) => String(v.id) === String(this.dataset.currentVariant));
        this.selected = start ? start.options.slice() : [];
        this.querySelectorAll('[data-option-group]').forEach((group) => {
          const idx = parseInt(group.dataset.optionIndex, 10);
          if (this.selected[idx] !== undefined) return;
          const chosen = group.querySelector('[aria-pressed="true"]');
          const first = group.querySelector('[data-option-value]');
          const node = chosen || first;
          if (node) this.selected[idx] = node.dataset.optionValue;
        });

        this.bind();
        this.refresh();
      }

      money(cents) {
        return window.bskMoney(cents, this.moneySuffix);
      }

      isMobile() {
        return window.matchMedia('(max-width: 1023px)').matches;
      }

      bind() {
        this.querySelectorAll('[data-option-value]').forEach((btn) => {
          btn.addEventListener('click', () => {
            if (btn.classList.contains('bsk-pdp__size')) {
              /* Hiç üretilmemiş kombinasyon (ör. bu renkte XS yok) seçilmez */
              if (btn.classList.contains('is-missing')) return;
              /* Tükenen beden yalnızca ayar açıksa seçilir */
              if (btn.classList.contains('is-unavailable') && !this.soldoutSelectable) return;
            }

            const fromSheet = btn.hasAttribute('data-sheet-size');
            const idx = parseInt(btn.dataset.optionIndex, 10);
            this.selected[idx] = btn.dataset.optionValue;

            this.sheetPick = fromSheet;
            this.refresh();
            this.sheetPick = false;

            /* Alttan açılan beden sayfasında:
               stokta  → sayfayı kapat, sepete ekle
               tükendi → sayfayı kapat, haber ver alanını ekrana getir */
            if (fromSheet && this.current) {
              this.closeSheet();
              if (this.current.available) {
                this.addToCart();
              } else {
                this.revealNotify();
              }
            }
          });
        });

        /* Renk satırındaki "+N": diğer renkleri aç/kapat */
        const moreBtn = this.querySelector('[data-color-more]');
        const colorSection = this.querySelector('[data-color-section]');
        if (moreBtn && colorSection) {
          moreBtn.addEventListener('click', () => {
            const open = colorSection.classList.toggle('is-expanded');
            moreBtn.setAttribute('aria-expanded', open ? 'true' : 'false');
          });
        }

        /* Sepete ekle: mobilde önce beden sayfası açılır (Bershka) */
        if (this.form) {
          this.form.addEventListener('submit', (event) => {
            event.preventDefault();
            this.requestAdd();
          });
        }

        const stickyBtn = this.pdp.querySelector('[data-sticky-atc]');
        if (stickyBtn) {
          stickyBtn.addEventListener('click', () => this.requestAdd());
        }

        /* Beden sayfasını kapatma yolları */
        if (this.sheet) {
          this.sheet.querySelectorAll('[data-sheet-close]').forEach((el) => {
            el.addEventListener('click', () => this.closeSheet());
          });
          document.addEventListener('keydown', (event) => {
            if (event.key === 'Escape' && !this.sheet.hidden) this.closeSheet();
          });
        }
      }

      /* Sepete ekleme isteği: beden sayfası gerekiyorsa onu aç */
      requestAdd() {
        if (this.sheet && this.isMobile()) {
          this.openSheet();
          return;
        }
        this.addToCart();
      }

      openSheet() {
        if (!this.sheet) return;
        this.sheet.hidden = false;
        document.documentElement.style.overflow = 'hidden';
        window.requestAnimationFrame(() => this.sheet.classList.add('is-open'));
        const first = this.sheet.querySelector('[data-sheet-size]:not(.is-unavailable)');
        if (first) first.focus({ preventScroll: true });
      }

      closeSheet() {
        if (!this.sheet || this.sheet.hidden) return;
        this.sheet.classList.remove('is-open');
        document.documentElement.style.overflow = '';
        window.setTimeout(() => { this.sheet.hidden = true; }, 260);
      }

      /* Seçili değerlere uyan varyantı bul */
      match(values) {
        return this.variants.find((v) =>
          values.every((val, i) => val === undefined || v.options[i] === val)
        );
      }

      refresh() {
        /* Aktif buton görünümleri (panel + beden sayfası birlikte) */
        this.querySelectorAll('[data-option-group]').forEach((group) => {
          const idx = parseInt(group.dataset.optionIndex, 10);
          group.querySelectorAll('[data-option-value]').forEach((btn) => {
            const isOn = btn.dataset.optionValue === this.selected[idx];
            btn.classList.toggle('is-selected', isOn);
            btn.setAttribute('aria-pressed', isOn ? 'true' : 'false');

            /* Diğer seçimler sabitken bu değer mevcut mu.
               is-missing     : böyle bir varyant hiç yok
               is-unavailable : hiç yok ya da tükenmiş */
            const probe = this.selected.slice();
            probe[idx] = btn.dataset.optionValue;
            const found = this.variants.find((v) =>
              probe.every((val, i) => val === undefined || v.options[i] === val)
            );
            btn.classList.toggle('is-unavailable', !found || !found.available);
            btn.classList.toggle('is-missing', !found);
          });
        });

        const variant = this.match(this.selected);
        this.current = variant;

        if (!variant) {
          if (this.atc) {
            this.atc.disabled = true;
            if (this.atcLabel) {
              this.atcLabel.textContent = this.atc.dataset.soldoutLabel || 'Tükendi';
            }
          }
          this.syncSoldOutMsg(null);
          return;
        }

        /* ----------------------------------------------------------
           Adres çubuğu + gizli id
           Stok bildirimi gibi uygulamalar seçili varyantı bu ikisinden
           okuyor. Önce adres güncelleniyor ki change olayını dinleyen
           uygulama ?variant= değerini de doğru görsün. Değeri JS ile
           değiştirmek tarayıcıda olay tetiklemediği için change olayı
           elle gönderiliyor.
           ---------------------------------------------------------- */
        if (window.history && window.history.replaceState && variant.url) {
          window.history.replaceState({}, '', variant.url);
        }
        if (this.idInput && String(this.idInput.value) !== String(variant.id)) {
          this.idInput.value = variant.id;
          this.idInput.dispatchEvent(new Event('change', { bubbles: true }));
        }

        /* Fiyat — TR biçimi burada da korunuyor */
        if (this.priceEl) {
          this.priceEl.textContent = this.money(variant.price);
          this.priceEl.classList.toggle('is-sale', !!variant.compare_at_price);
        }
        if (this.stickyPrice) this.stickyPrice.textContent = this.money(variant.price);
        if (this.compareEl) {
          if (variant.compare_at_price) {
            this.compareEl.textContent = this.money(variant.compare_at_price);
            this.compareEl.hidden = false;
          } else {
            this.compareEl.hidden = true;
          }
        }

        /* Ürün kodu (stok kodu / barkod). Önek Liquid'den geliyor, burada
           yalnızca kodun kendisi yazılıyor. Varyantta alan boşsa o kod
           gizlenir; hiç kod kalmazsa satırın tamamı gizlenir. */
        if (this.codeEls.length) {
          this.codeEls.forEach((el) => {
            const raw = variant[el.dataset.bskCode];
            const value = raw == null ? '' : String(raw).trim();
            const out = el.querySelector('[data-bsk-code-value]');
            if (out) out.textContent = value;
            el.hidden = !value;
          });
          this.codeWraps.forEach((wrap) => {
            wrap.hidden = !wrap.querySelector('[data-bsk-code]:not([hidden])');
          });
        }

        /* Renk adı */
        if (this.colorNameEl) {
          const colorGroup = this.querySelector('[data-color-section]');
          if (colorGroup) {
            const i = parseInt(colorGroup.dataset.optionIndex, 10);
            this.colorNameEl.textContent = variant.options[i] || '';
          }
        }

        /* Sepet butonu */
        const soldOut = this.atc ? (this.atc.dataset.soldoutLabel || 'Tükendi') : '';
        const addText = this.atc ? (this.atc.dataset.addLabel || 'Sepete ekle') : '';

        if (this.atc) {
          /* Mobilde beden sayfası varsa buton hep aktif kalır; beden
             seçimi sayfanın içinde yapılıyor (Bershka davranışı). */
          const keepEnabled = this.sheet && this.isMobile();
          this.atc.disabled = keepEnabled ? false : !variant.available;
          if (this.atcLabel) {
            this.atcLabel.textContent = (variant.available || keepEnabled) ? addText : soldOut;
          }
        }
        if (this.stickyLabel) {
          this.stickyLabel.textContent = (variant.available || (this.sheet && this.isMobile()))
            ? addText
            : soldOut;
        }

        /* Varyant görseline kaydır */
        if (variant.media_id && this.mediaList) {
          const target = this.mediaList.querySelector('[data-media-id="' + variant.media_id + '"]');
          if (target && this.isMobile()) {
            this.mediaList.scrollTo({ left: target.offsetLeft, behavior: 'smooth' });
          }
        }

        this.syncSoldOutMsg(variant);
        this.announceVariant(variant);
      }

      /* ----------------------------------------------------------
         Tükenen beden yazısı
         Masaüstünde tükenen beden seçilince buton zaten "Tükendi"
         oluyor; yazı müşteriyi altındaki haber ver butonuna yönlendirir.
         Mobilde beden panelde seçilmiyor, o yüzden yazı yalnızca beden
         sayfasında tükenen bedene dokunulunca çıkar (yoksa renk
         değiştirmek bile "beden tükendi" yazdırırdı).
         ---------------------------------------------------------- */
      syncSoldOutMsg(variant) {
        if (!this.msg) return;
        const sheetMode = !!(this.sheet && this.isMobile());
        const show = !!(
          variant &&
          !variant.available &&
          this.soldoutMsg &&
          this.variants.length > 1 &&
          (!sheetMode || this.sheetPick)
        );

        if (show) {
          this.msg.textContent = this.soldoutMsg;
          this.msg.classList.remove('is-error');
          this.msg.hidden = false;
          this.msgSoldOut = true;
        } else if (this.msgSoldOut) {
          this.msg.textContent = '';
          this.msg.hidden = true;
          this.msgSoldOut = false;
        }
      }

      /* Diğer kodlar ve uygulamalar için tek bir olay:
         document.addEventListener('bsk:variant-change', (e) => e.detail.variant) */
      announceVariant(variant) {
        if (!variant || this.lastVariantId === variant.id) return;
        this.lastVariantId = variant.id;
        document.dispatchEvent(new CustomEvent('bsk:variant-change', {
          detail: { variant: variant, productUrl: this.dataset.productUrl || '' }
        }));
      }

      /* Mobil beden sayfasında tükenen beden seçilince: sayfa kapanır,
         Sepete ekle altındaki alan (haber ver butonu orada) ekrana gelir.
         Uygulamanın butonu göstermesi için kısa bir süre bekleniyor. */
      revealNotify() {
        if (!this.pdp) return;
        const target = this.pdp.querySelector('[data-bsk-slot="buy"]') || this.msg || this.atc;
        if (!target) return;
        const smooth = !window.matchMedia('(prefers-reduced-motion: reduce)').matches;

        window.setTimeout(() => {
          const rect = target.getBoundingClientRect();
          const vh = window.innerHeight || document.documentElement.clientHeight;
          if (rect.top < 80 || rect.bottom > vh - 96) {
            target.scrollIntoView({ behavior: smooth ? 'smooth' : 'auto', block: 'center' });
          }
        }, 320);
      }

      async addToCart() {
        if (!this.current || !this.current.available || !this.atc) return;

        const label = (this.atc && this.atc.dataset.addLabel)
          ? this.atc.dataset.addLabel
          : (this.atcLabel ? this.atcLabel.textContent : '');
        this.atc.disabled = true;
        if (this.atcLabel) this.atcLabel.textContent = 'Ekleniyor…';
        if (this.msg) this.msg.hidden = true;
        this.msgSoldOut = false;

        try {
          const root = (window.Shopify && window.Shopify.routes)
            ? window.Shopify.routes.root : '/';
          const response = await fetch(root + 'cart/add.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
            body: JSON.stringify({ items: [{ id: this.current.id, quantity: 1 }] })
          });

          if (!response.ok) {
            const err = await response.json().catch(() => ({}));
            throw new Error(err.description || err.message || 'Sepete eklenemedi.');
          }

          /* BSK Header sepet sayacı bu olayı dinliyor */
          document.dispatchEvent(new CustomEvent('cart:updated'));

          if (this.msg) {
            this.msg.textContent = 'Sepete eklendi.';
            this.msg.classList.remove('is-error');
            this.msg.hidden = false;
          }
          if (this.atcLabel) this.atcLabel.textContent = label;
          this.atc.disabled = false;
        } catch (error) {
          if (this.msg) {
            this.msg.textContent = error.message;
            this.msg.classList.add('is-error');
            this.msg.hidden = false;
          }
          if (this.atcLabel) this.atcLabel.textContent = label;
          this.atc.disabled = false;
        }
      }
    }

    window.customElements.define('product-form-bsk', ProductFormBsk);
  }

  /* ============ Galeri, zoom, akordiyon, sabit çubuk ============ */
  (function () {
    const init = (scope) => {
      const pdp = (scope || document).querySelector('[data-bsk-pdp]');
      if (!pdp || pdp.dataset.bskInit) return;
      pdp.dataset.bskInit = 'true';

      /* ----------------------------------------------------------------
         MOBİL: GÖRSEL YÜKSEKLİĞİNİ EKRANA GÖRE ÖLÇ

         Bershka mobilde görsele sabit oran vermiyor. Görsel, ekrandan
         panelin ilk ekranda görünen kısmı (başlık + fiyat + renk +
         sepete ekle) düşüldükten sonra kalan alanı kaplıyor.

         Ölçüm panelin kendi içinden alınıyor, yani başlık iki satıra
         düşse veya header yüksekliği değişse görsel kendini kısaltıyor.
         Sonuç: panel her zaman ilk ekranda tam görünür, sabit alt buton
         hiçbir yazının üstüne binmez.
         ---------------------------------------------------------------- */
      const galleryBox = pdp.querySelector('.bsk-pdp__gallery');
      const infoBox = pdp.querySelector('.bsk-pdp__info');
      const atcBox = pdp.querySelector('.bsk-pdp__actions') || pdp.querySelector('[data-atc]');

      const fitGallery = () => {
        if (!galleryBox || !infoBox || !atcBox) return;

        /* Doğal oran modunda görsel kendi yüksekliğini belirliyor;
           buradan piksel yükseklik verirsek oranı bozar ve kırpma
           geri gelir. O yüzden hesaba hiç girmiyoruz. */
        const natural = pdp.classList.contains('bsk-pdp--media-natural');

        const mobile = window.matchMedia('(max-width: 1023px)').matches;
        if (!mobile || natural || pdp.dataset.fitMobile === 'false') {
          pdp.classList.remove('bsk-pdp--fit-mobile');
          galleryBox.style.height = '';
          return;
        }

        const vh = window.innerHeight;

        /* Galerinin sayfa başından uzaklığı: header, breadcrumb vs.
           Galerinin kendi yüksekliğinden etkilenmez. */
        const offsetTop = galleryBox.getBoundingClientRect().top + window.pageYOffset;

        /* Panel üstünden butonun altına kadar + panelin alt boşluğu.
           İkisi de aynı karede ölçüldüğü için kaydırmadan etkilenmez. */
        const infoTop = infoBox.getBoundingClientRect().top;
        const actionsBottom = atcBox.getBoundingClientRect().bottom;
        const padBottom = parseFloat(window.getComputedStyle(infoBox).paddingBottom) || 20;
        const needed = Math.ceil(actionsBottom - infoTop + padBottom);

        let h = vh - offsetTop - needed;
        const min = Math.round(vh * 0.42);
        const max = Math.round(vh * 0.92);
        if (h < min) h = min;
        if (h > max) h = max;

        pdp.classList.add('bsk-pdp--fit-mobile');
        galleryBox.style.height = Math.round(h) + 'px';
      };

      let fitTimer = null;
      const queueFit = () => {
        if (fitTimer) window.clearTimeout(fitTimer);
        fitTimer = window.setTimeout(fitGallery, 80);
      };

      fitGallery();
      window.addEventListener('resize', queueFit);
      window.addEventListener('orientationchange', queueFit);

      /* Header görselin üzerine binince sarmalayıcılar sıfırlanıyor ve
         galerinin sayfa başına uzaklığı değişiyor; o an yeniden ölç. */
      document.addEventListener('bsk:layout', queueFit);
      window.addEventListener('load', queueFit);

      /* Yazı tipi sonradan yüklenirse başlık sarması değişebilir */
      if (document.fonts && document.fonts.ready) {
        document.fonts.ready.then(fitGallery).catch(() => {});
      }

      /* Panel yüksekliği değişirse (uzun başlık, indirim etiketi,
         sonradan yüklenen uygulama bloğu vs.) */
      if ('ResizeObserver' in window && infoBox) {
        new ResizeObserver(queueFit).observe(infoBox);
      }

      /* ----------------------------------------------------------------
         GÖRÜNMEZ UYGULAMA BLOKLARI BOŞLUK BIRAKMASIN

         Stok bildirim butonu gibi bloklar çoğu zaman görünmez durur
         (seçili beden stoktaysa). Yüksekliği sıfır olan blok ve alan
         işaretleniyor; CSS çevresindeki aralığı geri alıyor. Uygulama
         içeriğini sonradan gösterince yükseklik değişiyor, işaret
         kendiliğinden kalkıyor.
         ---------------------------------------------------------------- */
      const collapsibles = pdp.querySelectorAll('[data-bsk-collapse]');
      if (collapsibles.length && 'ResizeObserver' in window) {
        const collapseObserver = new ResizeObserver((entries) => {
          entries.forEach((entry) => {
            entry.target.classList.toggle('is-collapsed', entry.contentRect.height < 1);
          });
        });
        collapsibles.forEach((el) => collapseObserver.observe(el));
      }

      /* --- Mobil galeri noktaları --- */
      const list = pdp.querySelector('[data-media-list]');
      const dots = pdp.querySelectorAll('[data-dots] .bsk-pdp__dot');
      if (list && dots.length) {
        let queued = false;
        list.addEventListener('scroll', () => {
          if (queued) return;
          queued = true;
          window.requestAnimationFrame(() => {
            const i = Math.round(list.scrollLeft / (list.clientWidth || 1));
            dots.forEach((d, n) => d.classList.toggle('is-active', n === i));
            queued = false;
          });
        }, { passive: true });
      }

      /* ----------------------------------------------------------------
         FİLM ŞERİDİ: otomatik geçiş, oklar, sürükleme

         MASAÜSTÜNDE SONSUZ DÖNGÜ
         Görsel listesi kopyalanıyor: asıl listenin soluna bir takım,
         sağına ekranı dolduracak kadar. Şerit asıl listenin dışında
         durduğu anda, aynı görüntüye denk gelen asıl konuma sessizce
         atlanıyor; kopyalar birebir aynı olduğu için atlama görünmez.
         Böylece son görselden sonra ilk görsel sağdan gelir ve panelin
         altında kalan görsel de kayarak açığa çıkar.

         Mobilde döngü yok: kopyalar CSS ile gizli, şerit eskisi gibi
         sonda başa sarar.
         ---------------------------------------------------------------- */
      if (list) {
        const reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
        const desktopMQ = window.matchMedia('(min-width: 1024px)');
        const gallery = pdp.querySelector('.bsk-pdp__gallery');
        const prev = pdp.querySelector('[data-strip-prev]');
        const next = pdp.querySelector('[data-strip-next]');
        const playBtns = pdp.querySelectorAll('[data-strip-play]');
        const speed = parseInt(pdp.dataset.stripSpeed, 10) || 5000;
        const wantsAuto = pdp.dataset.stripAutoplay === 'true' && !reduce;
        const originals = Array.from(list.querySelectorAll('[data-media-item]'));

        let timer = null;
        let paused = false;
        let hovering = false;
        let focusInside = false;
        let inView = true;
        let drag = null;
        let snapPending = false;
        let settleTimer = null;
        let layoutQueued = false;
        let warmed = false;

        /* home   : asıl listenin ilk görseli sola dayalıyken kaydırma konumu
           period : bir tam listenin genişliği (aralıklar dahil)
           unit   : bir görsel + bir aralık
           after  : asıl listenin sağına eklenen kopya takımı sayısı */
        const loop = { on: false, built: false, home: 0, period: 0, unit: 0, after: 0 };

        const gapPx = () => parseFloat(window.getComputedStyle(list).columnGap) || 0;

        const step = () => {
          if (loop.on && loop.unit) return loop.unit;
          const item = originals[0];
          return item ? item.getBoundingClientRect().width + gapPx() : 0;
        };

        /* Öğenin şerit içindeki kaydırma konumu */
        const posOf = (el) =>
          el.getBoundingClientRect().left - list.getBoundingClientRect().left + list.scrollLeft;

        /* CSS'teki yumuşak kaydırmayı ezerek anında konumlan */
        const jump = (x) => {
          const before = list.style.scrollBehavior;
          list.style.scrollBehavior = 'auto';
          list.scrollLeft = x;
          list.style.scrollBehavior = before;
        };

        /* Konumu asıl listenin aralığına katla */
        const wrap = (x) => {
          const p = loop.period;
          let rel = (((x - loop.home) % p) + p) % p;
          if (rel > p - 2) rel -= p;
          return loop.home + rel;
        };

        /* Şerit asıl listenin dışında duruyorsa karşılığına atla.
           Klavye odağı şeritteyken atlanmaz, odaklı görsel ekrandan
           kaçmasın diye. */
        const normalize = () => {
          if (!loop.on || drag || focusInside) return;
          const x = list.scrollLeft;
          const target = wrap(x);
          if (Math.abs(target - x) > 1) jump(target);
        };

        /* Kopya: ekran okuyucudan ve klavyeden gizli; fareyle tıklanınca
           asıl görsel gibi büyütülür */
        const makeClone = (item) => {
          const c = item.cloneNode(true);
          c.removeAttribute('data-media-item');
          c.removeAttribute('data-media-id');
          c.setAttribute('data-media-clone', '');
          c.setAttribute('aria-hidden', 'true');
          c.querySelectorAll('[id]').forEach((el) => el.removeAttribute('id'));
          c.querySelectorAll('[fetchpriority]').forEach((el) => el.removeAttribute('fetchpriority'));
          c.querySelectorAll('button, a, iframe, video').forEach((el) => el.setAttribute('tabindex', '-1'));
          return c;
        };

        const cloneSet = () => {
          const frag = document.createDocumentFragment();
          originals.forEach((item) => frag.appendChild(makeClone(item)));
          return frag;
        };

        /* Kopya videolar da sessiz oynasın; muted özelliği kopyaya her
           tarayıcıda kendiliğinden geçmiyor */
        const playCloneVideos = () => {
          list.querySelectorAll('[data-media-clone] video').forEach((v) => {
            v.muted = true;
            if (v.autoplay && v.paused) {
              const p = v.play();
              if (p && typeof p.catch === 'function') p.catch(() => {});
            }
          });
        };

        /* Atlama anında boş kare görünmesin: sayfa yüklendikten sonra
           şeridin geri kalan görselleri de indirilir (yalnızca masaüstü) */
        const warmImages = () => {
          if (warmed) return;
          warmed = true;
          const run = () => {
            list.querySelectorAll('img[loading="lazy"]').forEach((img) => { img.loading = 'eager'; });
          };
          if (document.readyState === 'complete') {
            run();
          } else {
            window.addEventListener('load', run, { once: true });
          }
        };

        /* Kopyaları kur (ekran büyüdüyse yenisini ekle) ve ölç */
        const buildLoop = () => {
          if (originals.length < 2) return false;
          const unit = originals[0].getBoundingClientRect().width + gapPx();
          if (!unit) return false;
          const period = unit * originals.length;
          let added = false;

          if (!loop.built) {
            list.insertBefore(cloneSet(), list.firstChild);
            loop.built = true;
            added = true;
          }

          /* Sağdaki kopyalar en az bir ekran + bir görsel genişliğinde olmalı */
          const need = Math.max(1, Math.ceil((list.clientWidth + unit) / period));
          while (loop.after < need) {
            list.appendChild(cloneSet());
            loop.after += 1;
            added = true;
          }
          if (added) playCloneVideos();

          loop.unit = unit;
          loop.period = period;
          loop.home = posOf(originals[0]);
          return true;
        };

        const atEnd = () => list.scrollLeft + list.clientWidth >= list.scrollWidth - 4;

        /* Döngüde oklar hiç kapanmaz; mobilde ve tek görselde eski kural */
        const syncArrows = () => {
          if (!prev || !next) return;
          if (loop.on) {
            prev.disabled = false;
            next.disabled = false;
            return;
          }
          prev.disabled = list.scrollLeft <= 4;
          next.disabled = atEnd();
        };

        const layout = () => {
          layoutQueued = false;
          if (!list.isConnected) return;

          if (desktopMQ.matches) {
            /* Ölçülemiyorsa (gizli vb.) bir sonraki boyut değişimini bekle */
            if (!buildLoop()) return;
            if (!loop.on) {
              loop.on = true;
              jump(loop.home);
              warmImages();
            } else {
              normalize();
            }
          } else if (loop.on) {
            /* Mobile geçildi: kopyalar CSS ile gizlendi, şerit başa döner */
            loop.on = false;
            jump(0);
          }
          syncArrows();
        };

        const queueLayout = () => {
          if (layoutQueued) return;
          layoutQueued = true;
          window.requestAnimationFrame(layout);
        };

        const advance = () => {
          if (loop.on) {
            normalize();
            list.scrollBy({ left: loop.unit, behavior: 'smooth' });
          } else if (atEnd()) {
            list.scrollTo({ left: 0, behavior: 'smooth' });
          } else {
            list.scrollBy({ left: step(), behavior: 'smooth' });
          }
        };

        const back = () => {
          if (loop.on) {
            normalize();
            list.scrollBy({ left: -loop.unit, behavior: 'smooth' });
          } else if (list.scrollLeft <= 4) {
            list.scrollTo({ left: list.scrollWidth, behavior: 'smooth' });
          } else {
            list.scrollBy({ left: -step(), behavior: 'smooth' });
          }
        };

        const start = () => {
          if (timer || paused || hovering || focusInside || !inView || !wantsAuto) return;
          timer = window.setInterval(advance, speed);
        };

        const stop = () => {
          if (!timer) return;
          window.clearInterval(timer);
          timer = null;
        };

        if (prev) prev.addEventListener('click', () => { back(); stop(); start(); });
        if (next) next.addEventListener('click', () => { advance(); stop(); start(); });

        /* Mobildeki ve masaüstündeki oynat/duraklat butonları birlikte çalışır */
        playBtns.forEach((btn) => {
          btn.addEventListener('click', () => {
            paused = !paused;
            playBtns.forEach((b) => {
              b.setAttribute('aria-pressed', paused ? 'false' : 'true');
              b.setAttribute('aria-label', paused
                ? 'Görsel geçişini başlat'
                : 'Görsel geçişini duraklat');
            });
            if (paused) { stop(); } else { start(); }
          });
        });

        /* Fare şeridin üzerindeyken durdur */
        if (gallery) {
          gallery.addEventListener('pointerenter', (event) => {
            if (event.pointerType !== 'mouse') return;
            hovering = true;
            stop();
          });
          gallery.addEventListener('pointerleave', (event) => {
            if (event.pointerType !== 'mouse') return;
            hovering = false;
            start();
          });
        }

        /* Klavye odağı şeritteyken geçiş durur (hareketli içerik) */
        list.addEventListener('focusin', () => {
          focusInside = true;
          stop();
        });
        list.addEventListener('focusout', (event) => {
          if (event.relatedTarget && list.contains(event.relatedTarget)) return;
          focusInside = false;
          normalize();
          start();
        });

        /* Kaydırma durunca: sürüklemeden sonra yapışmayı geri aç ve
           şerit asıl listenin dışındaysa karşılığına atla */
        const onSettle = () => {
          if (settleTimer) {
            window.clearTimeout(settleTimer);
            settleTimer = null;
          }
          if (drag) return;
          if (snapPending) {
            snapPending = false;
            list.style.scrollSnapType = '';
          }
          normalize();
        };

        list.addEventListener('scroll', () => {
          syncArrows();
          if (settleTimer) window.clearTimeout(settleTimer);
          settleTimer = window.setTimeout(onSettle, 160);
        }, { passive: true });

        if ('onscrollend' in window) list.addEventListener('scrollend', onSettle);

        document.addEventListener('visibilitychange', () => {
          if (document.hidden) { stop(); } else { start(); }
        });

        /* Sadece görünürken çalış */
        if ('IntersectionObserver' in window && gallery) {
          new IntersectionObserver((entries) => {
            entries.forEach((e) => {
              inView = e.isIntersecting;
              if (inView) { start(); } else { stop(); }
            });
          }, { threshold: 0.2 }).observe(gallery);
        } else {
          start();
        }

        /* ------------------------------------------------------------
           Fare ile sürükleyerek kaydırma (masaüstü)
           Sürüklerken yapışma (snap) kapatılıyor, yoksa şerit her
           harekette en yakın görsele sıçrar. Bırakınca en yakın görsele
           yumuşakça oturur; yeterince sürüklendiyse son hareket
           yönündeki görsele geçer. Döngüde sürükleme de uca dayanmaz.
           ------------------------------------------------------------ */
        list.addEventListener('dragstart', (event) => event.preventDefault());

        list.addEventListener('pointerdown', (event) => {
          /* Parmakla kaydırırken otomatik geçiş araya girmesin */
          if (event.pointerType === 'touch') {
            stop();
            return;
          }
          if (event.pointerType !== 'mouse' || event.button !== 0) return;
          if (!desktopMQ.matches) return;
          drag = { x: event.clientX, lastX: event.clientX, left: list.scrollLeft, moved: 0, dir: 0 };
          list.style.scrollBehavior = 'auto';
          list.style.scrollSnapType = 'none';
        });

        list.addEventListener('pointermove', (event) => {
          if (!drag) return;
          const dx = event.clientX - drag.x;
          const mv = event.clientX - drag.lastX;
          if (mv) drag.dir = mv < 0 ? 1 : -1;
          drag.lastX = event.clientX;
          drag.moved = Math.max(drag.moved, Math.abs(dx));
          if (drag.moved > 4) list.classList.add('is-dragging');

          let target = drag.left - dx;
          if (loop.on) {
            const wrapped = wrap(target);
            drag.left += wrapped - target;
            target = wrapped;
          }
          list.scrollLeft = target;
        });

        const endDrag = () => {
          if (!drag) return;
          const d = drag;
          drag = null;
          list.classList.remove('is-dragging');
          list.style.scrollBehavior = '';

          if (d.moved > 8) {
            list.dataset.justDragged = 'true';
            window.setTimeout(() => { delete list.dataset.justDragged; }, 60);
          }

          const unit = step();
          const base = loop.on ? loop.home : 0;
          let target = list.scrollLeft;
          if (unit && d.moved > 1) {
            const rel = (list.scrollLeft - base) / unit;
            let idx = Math.round(rel);
            if (d.moved > 40 && d.dir) {
              idx = d.dir > 0 ? Math.ceil(rel - 0.02) : Math.floor(rel + 0.02);
            }
            target = base + idx * unit;
          }

          if (Math.abs(target - list.scrollLeft) < 1) {
            list.style.scrollSnapType = '';
            normalize();
            return;
          }
          snapPending = true;
          list.scrollTo({ left: target, behavior: 'smooth' });
        };

        const endPointer = (event) => {
          if (event.pointerType === 'touch') {
            start();
            return;
          }
          endDrag();
        };
        list.addEventListener('pointerup', endPointer);
        list.addEventListener('pointerleave', endPointer);
        list.addEventListener('pointercancel', endPointer);

        /* İlk kurulum + boyut değişimleri (pencere, header, mobil/masaüstü geçişi) */
        layout();
        if ('ResizeObserver' in window) {
          const stripObserver = new ResizeObserver(queueLayout);
          stripObserver.observe(list);
          if (originals[0]) stripObserver.observe(originals[0]);
        }
        window.addEventListener('resize', () => {
          stop();
          queueLayout();
          start();
        });
      }

      /* --- Zoom --- */
      const zoom = pdp.querySelector('[data-zoom]');
      const zoomImg = pdp.querySelector('[data-zoom-img]');
      if (zoom && zoomImg) {
        if (zoom.parentElement !== document.body) document.body.appendChild(zoom);

        const open = (src, alt) => {
          zoomImg.src = src;
          zoomImg.alt = alt || '';
          zoom.hidden = false;
          document.documentElement.style.overflow = 'hidden';
          window.requestAnimationFrame(() => zoom.classList.add('is-open'));
          const closeBtn = zoom.querySelector('[data-zoom-close]');
          if (closeBtn) closeBtn.focus();
        };

        const close = () => {
          zoom.classList.remove('is-open');
          document.documentElement.style.overflow = '';
          window.setTimeout(() => { zoom.hidden = true; zoomImg.src = ''; }, 200);
        };

        /* Tıklama şerit üzerinden yakalanıyor; böylece döngü için
           sonradan eklenen kopyalar da büyütülebiliyor */
        if (list) {
          list.addEventListener('click', (event) => {
            const btn = event.target.closest('[data-zoom-open]');
            if (!btn || !list.contains(btn)) return;
            if (list.dataset.justDragged) return;
            const img = btn.querySelector('img');
            open(btn.dataset.zoomSrc, img ? img.alt : '');
          });
        }

        const first = pdp.querySelector('[data-zoom-first]');
        if (first) {
          first.addEventListener('click', () => {
            const btn = pdp.querySelector('[data-media-item] [data-zoom-open]');
            if (btn) {
              const img = btn.querySelector('img');
              open(btn.dataset.zoomSrc, img ? img.alt : '');
            }
          });
        }

        zoom.querySelectorAll('[data-zoom-close]').forEach((el) => {
          el.addEventListener('click', close);
        });
        zoom.addEventListener('click', (event) => {
          if (event.target === zoom || event.target.hasAttribute('data-zoom-stage')) close();
        });
        document.addEventListener('keydown', (event) => {
          if (event.key === 'Escape' && !zoom.hidden) close();
        });
      }

      /* --- Detay akordiyonu (açık gelme durumu Liquid'den) --- */
      pdp.querySelectorAll('[data-detail-toggle]').forEach((btn) => {
        btn.addEventListener('click', () => {
          const body = document.getElementById(btn.getAttribute('aria-controls'));
          const isOpen = btn.getAttribute('aria-expanded') === 'true';
          btn.setAttribute('aria-expanded', isOpen ? 'false' : 'true');
          if (body) body.classList.toggle('is-open', !isOpen);
        });
      });

      /* --- Favori: görsel üstündeki ve paneldeki buton eş zamanlı --- */
      const wishes = pdp.querySelectorAll('[data-wishlist]');
      wishes.forEach((btn) => {
        btn.addEventListener('click', () => {
          const on = btn.getAttribute('aria-pressed') === 'true';
          wishes.forEach((b) => b.setAttribute('aria-pressed', on ? 'false' : 'true'));
        });
      });

      /* --- Mobil sabit çubuk: sepet butonu ekrandan çıkınca göster --- */
      const bar = pdp.querySelector('[data-sticky-bar]');
      const atc = pdp.querySelector('[data-atc]');
      if (bar && atc && 'IntersectionObserver' in window) {
        bar.hidden = false;
        const io = new IntersectionObserver((entries) => {
          entries.forEach((entry) => {
            bar.classList.toggle('is-visible', !entry.isIntersecting);
          });
        }, { threshold: 0 });
        io.observe(atc);
      }
    };

    if (document.readyState !== 'loading') {
      init(document);
    } else {
      document.addEventListener('DOMContentLoaded', () => init(document));
    }
    document.addEventListener('shopify:section:load', (event) => init(event.target));
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["bsk-review-badge"] && !Shopify.designMode) return;
  try {
    
  (function () {
    'use strict';
    if (window.__bskVerifiedBadge) return;
    window.__bskVerifiedBadge = true;

    /* ----------------------------------------------------------------
       YORUM ALANI
       Sınıf ya da kimliğinde bunlardan biri geçen kutular yorum alanı
       sayılıyor. "preview" (önizleme) bilerek dışarıda bırakılıyor.
       ---------------------------------------------------------------- */
    const AREA_SEL = [
      '[id*="review" i]', '[class*="review" i]',
      '[id*="yorum" i]', '[class*="yorum" i]',
      '[id*="degerlendirme" i]', '[class*="degerlendirme" i]',
      '[id*="değerlendirme" i]', '[class*="değerlendirme" i]',
      '[class*="jdgm"]',
      '[id*="trendyol" i]', '[class*="trendyol" i]'
    ].join(',');
    const AREA_SEL_OLD = '[id*="review"],[class*="review"],[id*="yorum"],[class*="yorum"],[class*="jdgm"]';
    const AREA_RE = /(?:^|[^p])review|yorum|de[gğ]erlendirme|jdgm|trendyol/i;

    /* Bilinen uygulamaların yorum tarihi */
    const KNOWN_SEL = '.kl_reviews__review__timestamp, .jdgm-rev__timestamp';

    /* Mağaza yanıtı ve soru-cevap: rozet eklenmez. Yalnızca tarihin
       yakınındaki birkaç üst öğeye bakılıyor; sayfanın geneline değil. */
    const SKIP_RE = /reply|response|yan[ıi]t|answer|cevap|question/i;

    /* Kendi öğelerimiz ve metin taşımayan etiketler */
    const OWN_SEL = '.bsk-vb, .bsk-vb-pop, .bsk-vb-marker, [data-bsk-vb-config], script, style, noscript, template, textarea, select, option';

    /* Uygulamanın kendi doğrulanmış rozeti */
    const NATIVE_TEXT = /^(?:✓\s*)?(?:do[gğ]rulanm[ıi][sş]|verified)/i;
    const NATIVE_CLASS = /verified|buyer[-_]?badge|dogrulan/i;

    /* ----------------------------------------------------------------
       TARİH BİÇİMLERİ
       09/01/2026, 09.01.2026, 2026-01-09, 9 Ocak 2026, Jan 9, 2026,
       2 hafta önce, dün, 3 days ago... İsteğe bağlı saatle birlikte.
       ---------------------------------------------------------------- */
    const TR_M = '(?:oca(?:k)?|[şs]ub(?:at)?|mar(?:t)?|nis(?:an)?|may(?:[ıi]s)?|haz(?:iran)?|tem(?:muz)?|a[ğg]u(?:stos)?|eyl(?:[üu]l)?|eki(?:m)?|kas(?:[ıi]m)?|ara(?:l[ıi]k)?)';
    const EN_M = '(?:jan(?:uary)?|feb(?:ruary)?|mar(?:ch)?|apr(?:il)?|may|jun(?:e)?|jul(?:y)?|aug(?:ust)?|sep(?:t(?:ember)?)?|oct(?:ober)?|nov(?:ember)?|dec(?:ember)?)';
    const TIME = '(?:,?\\s+\\d{1,2}:\\d{2}(?::\\d{2})?)?';
    const DATE_RES = [
      new RegExp('^\\d{1,2}[./-]\\d{1,2}[./-](?:\\d{4}|\\d{2})' + TIME + '$'),
      new RegExp('^\\d{4}[./-]\\d{1,2}[./-]\\d{1,2}' + TIME + '$'),
      new RegExp('^\\d{1,2}\\.?\\s+' + TR_M + '\\.?\\s+\\d{4}' + TIME + '$', 'i'),
      new RegExp('^\\d{1,2}\\.?\\s+' + EN_M + '\\.?,?\\s+\\d{4}' + TIME + '$', 'i'),
      new RegExp('^' + EN_M + '\\.?\\s+\\d{1,2},?\\s+\\d{4}' + TIME + '$', 'i'),
      /^(?:\d+|bir)\s+(?:saniye|dakika|saat|g[üu]n|hafta|ay|y[ıi]l)\s+[öo]nce$/i,
      /^(?:\d+|an?|one)\s+(?:seconds?|minutes?|hours?|days?|weeks?|months?|years?)\s+ago$/i,
      /^(?:bug[üu]n|d[üu]n|az [öo]nce|today|yesterday|just now)$/i
    ];

    const norm = (s) => (s || '').replace(/\s+/g, ' ').replace(/^[\s•·|,–—-]+|[\s•·|,–—-]+$/g, '');
    const isDate = (s) => {
      const t = norm(s);
      return !!t && t.length <= 34 && DATE_RES.some((re) => re.test(t));
    };

    /* İkonlar: dolu daire içinde boş tik (tik, zeminin rengini gösterir)
       ve ince çizgili (i) */
    const CHECK_SVG =
      '<svg class="bsk-vb__check" viewBox="2 2 16 16" aria-hidden="true" focusable="false">' +
        '<path fill-rule="evenodd" clip-rule="evenodd" d="M10 2a8 8 0 1 0 0 16a8 8 0 1 0 0-16ZM7.101 9.649l1.78 1.78 4.1-4.361a.85.85 0 0 1 1.238 1.164l-5.3 5.639-3.02-3.02a.85.85 0 0 1 1.202-1.202Z"/>' +
      '</svg>';
    const INFO_SVG =
      '<svg class="bsk-vb__i" viewBox="0 0 20 20" aria-hidden="true" focusable="false">' +
        '<circle class="ring" cx="10" cy="10" r="8.6" stroke-width="1.3"/>' +
        '<path class="stem" d="M10 9v5" stroke-width="1.5" stroke-linecap="round"/>' +
        '<circle class="dot" cx="10" cy="6.35" r="0.95"/>' +
      '</svg>';

    /* ---------------- Durum ---------------- */
    let cfg = null;
    let cfgKey = '';
    let bootTime = 0;
    let done = new WeakSet();
    let entries = [];
    let mo = null;
    let scanTimer = null;
    let statusTimer = null;
    const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    const readCfg = () => {
      const el = document.querySelector('[data-bsk-vb-config]');
      if (!el) return null;
      try {
        const c = JSON.parse(el.textContent || '{}');
        return {
          badge: String(c.badge || 'Doğrulanmış müşteri'),
          text: String(c.text || ''),
          linkLabel: String(c.linkLabel || ''),
          linkUrl: String(c.linkUrl || ''),
          anchor: String(c.anchor || '').trim(),
          skipNative: c.skipNative !== false
        };
      } catch (e) {
        return null;
      }
    };

    const hasInfo = () => !!(cfg && (cfg.text || (cfg.linkUrl && cfg.linkLabel)));
    const classOf = (el) => (el.id || '') + ' ' + (el.getAttribute('class') || '');
    const visible = (el) => el.getClientRects().length > 0;

    /* ---------------- Yorumları bul ---------------- */
    const findRoots = () => {
      let found;
      try {
        found = document.querySelectorAll(AREA_SEL);
      } catch (e) {
        found = document.querySelectorAll(AREA_SEL_OLD);
      }
      const list = [];
      found.forEach((el) => {
        if (el === document.body || el === document.documentElement) return;
        if (!AREA_RE.test(classOf(el)) || el.closest(OWN_SEL)) return;
        list.push(el);
      });
      /* Yalnızca en dıştaki kutular; içtekiler zaten onların içinde taranıyor */
      const set = new Set(list);
      return list.filter((el) => {
        for (let p = el.parentElement; p; p = p.parentElement) {
          if (set.has(p)) return false;
        }
        return true;
      });
    };

    /* Kutunun içinde yalnızca tarih yazan öğeler */
    const findDates = (root) => {
      const out = [];
      const seen = new Set();
      const walker = document.createTreeWalker(root, NodeFilter.SHOW_TEXT);
      for (let n = walker.nextNode(); n; n = walker.nextNode()) {
        const v = n.nodeValue;
        if (!v || v.length > 80) continue;
        const el = n.parentElement;
        if (!el || seen.has(el)) continue;
        seen.add(el);
        if (isDate(el.textContent)) out.push(el);
      }
      root.querySelectorAll('time').forEach((t) => out.push(t));
      return out;
    };

    /* Mağaza yanıtı / soru-cevap içinde mi (tarihin yakın üstlerine bakar) */
    const nearSkip = (el) => {
      let p = el;
      for (let i = 0; i < 5 && p && p !== document.body; i++, p = p.parentElement) {
        if (SKIP_RE.test(classOf(p))) return true;
      }
      return false;
    };

    /* Kendi öğelerimizi ve iç içe geçenleri ayıkla, sırayı koru */
    const clean = (list, auto) => {
      const out = [];
      list.forEach((el) => {
        if (!el || !el.isConnected || el.closest(OWN_SEL)) return;
        if (auto && nearSkip(el)) return;
        for (let i = 0; i < out.length; i++) {
          const o = out[i];
          if (o === el || o.contains(el) || el.contains(o)) return;
        }
        out.push(el);
      });
      return out;
    };

    const findAnchors = () => {
      if (cfg.anchor) {
        let list = [];
        try {
          list = Array.from(document.querySelectorAll(cfg.anchor));
        } catch (e) {
          list = [];
        }
        return clean(list, false);
      }
      let list = Array.from(document.querySelectorAll(KNOWN_SEL));
      findRoots().forEach((root) => { list = list.concat(findDates(root)); });
      return clean(list, true);
    };

    const containsOther = (el, anchor, all) => all.some((a) => a !== anchor && el.contains(a));

    /* ----------------------------------------------------------------
       İSİM SATIRI
       Tarihten yukarı en fazla üç kat çıkılıp yatay dizilmiş (flex,
       satır yönünde) ilk kutu aranıyor: avatar + isim + tarih satırı.
       Başka bir yorumun tarihini de içeren kutuya çıkılmıyor; yoksa
       rozet yorum listesinin kendisine eklenirdi.
       ---------------------------------------------------------------- */
    const findRow = (anchor, all) => {
      let child = anchor;
      for (let i = 0; i < 3; i++) {
        const p = child.parentElement;
        if (!p || p === document.body || p === document.documentElement) return null;
        if (containsOther(p, anchor, all)) return null;
        const cs = window.getComputedStyle(p);
        const isFlex = cs.display === 'flex' || cs.display === 'inline-flex';
        if (isFlex && cs.flexDirection === 'row' && p.children.length > 1) {
          return { row: p, probe: child };
        }
        child = p;
      }
      return null;
    };

    /* Uygulamanın kendi rozetine bakılacak alan: satırın bir üstü
       (yorum kartı), başka yorum içermiyorsa */
    const cardOf = (start, anchor, all) => {
      const p = start.parentElement;
      if (p && p !== document.body && !containsOther(p, anchor, all)) return p;
      return start;
    };

    const hasNative = (scope) => {
      if (!scope || !scope.isConnected) return false;
      const els = scope.getElementsByTagName('*');
      const max = Math.min(els.length, 300);
      for (let i = 0; i < max; i++) {
        const el = els[i];
        if (el.closest('.bsk-vb')) continue;
        if (NATIVE_CLASS.test(el.getAttribute('class') || '') && visible(el)) return true;
        if (!el.firstElementChild) {
          const t = norm(el.textContent);
          if (t && t.length <= 40 && NATIVE_TEXT.test(t) && visible(el)) return true;
        }
      }
      return false;
    };

    /* ---------------- Rozet ---------------- */
    const makeBadge = () => {
      const info = hasInfo();
      const badge = document.createElement('span');
      badge.className = 'bsk-vb';
      badge.innerHTML =
        '<span class="bsk-vb__pill">' +
          '<span class="bsk-vb__label">' + CHECK_SVG + '<span class="bsk-vb__text"></span></span>' +
          (info
            ? '<span class="bsk-vb__sep" aria-hidden="true"></span>' +
              '<button type="button" class="bsk-vb__info" aria-haspopup="dialog" aria-expanded="false" aria-controls="BskVerifiedPop">' + INFO_SVG + '</button>'
            : '') +
        '</span>';
      badge.querySelector('.bsk-vb__text').textContent = cfg.badge;

      const btn = badge.querySelector('.bsk-vb__info');
      if (btn) {
        btn.setAttribute('aria-label', cfg.badge + ' hakkında bilgi');
        const pill = badge.querySelector('.bsk-vb__pill');
        /* Rozetin tamamı tıklanır. Yayılım durduruluyor: bazı
           uygulamalar yorum kartına tıklanınca kendi penceresini açıyor. */
        pill.addEventListener('click', (event) => {
          event.preventDefault();
          event.stopPropagation();
          if (pop.btn === btn) {
            closePop(false);
          } else {
            openPop(btn);
          }
        });
      }
      return badge;
    };

    /* İsmin başladığı sütun: avatar gibi en fazla iki harflik ya da
       yazısız kutular atlanıyor */
    const textStart = (row, probe) => {
      for (let i = 0; i < row.children.length; i++) {
        const c = row.children[i];
        if (c.classList.contains('bsk-vb') || !visible(c)) continue;
        if (norm(c.textContent).length > 2) return c;
      }
      return probe;
    };

    /* ----------------------------------------------------------------
       SIĞDIRMA
       Rozet satırın sağına konunca
       - isim sütunu daralıp alt satıra kayıyorsa,
       - satır taşıyorsa,
       - ya da yorum kartı genişliyorsa (liste grid olunca satır taşmaz,
         kart büyür ve sayfa yana kayar)
       rozet kendi satırına iner ve ismin başladığı hizadan başlar.
       Satırın genişliği her değiştiğinde yeniden bakılıyor.
       ---------------------------------------------------------------- */
    const fit = (entry) => {
      const { row, probe, badge } = entry;
      if (!row || !row.isConnected || !badge.isConnected) return;
      if (!row.clientWidth) return; /* gizli sekme: görünür olunca yeniden bakılır */

      badge.classList.remove('bsk-vb--below');
      if (entry.wrapSet) {
        row.style.flexWrap = entry.prevWrap;
        entry.wrapSet = false;
      }

      const card = entry.scope && entry.scope.isConnected ? entry.scope : row;
      const doc = document.documentElement;

      badge.style.setProperty('display', 'none', 'important');
      const h0 = probe.offsetHeight;
      const c0 = card.getBoundingClientRect().width;
      const d0 = doc.scrollWidth;
      badge.style.removeProperty('display');
      const h1 = probe.offsetHeight;
      const grew = card.getBoundingClientRect().width > c0 + 1 || doc.scrollWidth > d0 + 1;
      const overflow = row.scrollWidth > row.clientWidth + 1;
      const dropped = badge.getBoundingClientRect().top >= probe.getBoundingClientRect().bottom - 1;

      if (h1 > h0 + 1 || grew || overflow || dropped) {
        entry.prevWrap = row.style.flexWrap;
        row.style.flexWrap = 'wrap';
        entry.wrapSet = true;

        const cs = window.getComputedStyle(row);
        const rr = row.getBoundingClientRect();
        const sr = textStart(row, probe).getBoundingClientRect();
        const indent = Math.max(0, Math.round(sr.left - rr.left - (parseFloat(cs.paddingLeft) || 0) - (parseFloat(cs.borderLeftWidth) || 0)));
        const rowGap = parseFloat(cs.rowGap) || 0;
        badge.style.setProperty('--bsk-vb-indent', indent + 'px');
        badge.style.setProperty('--bsk-vb-mt', rowGap > 0 ? '0px' : '6px');
        badge.classList.add('bsk-vb--below');
      }

      /* Son genişlik: kendi değişikliğimiz ResizeObserver'ı döngüye sokmasın */
      entry.w = row.clientWidth;
    };

    const ro = 'ResizeObserver' in window
      ? new ResizeObserver((list) => {
          list.forEach((item) => {
            const entry = entries.find((e) => e.row === item.target);
            if (entry && item.target.clientWidth !== entry.w) fit(entry);
          });
        })
      : null;

    const refitAll = () => entries.forEach(fit);

    const attach = (anchor, all) => {
      if (done.has(anchor)) return;
      done.add(anchor);

      const place = findRow(anchor, all);
      if (place && place.row.querySelector(':scope > .bsk-vb')) return;

      const scope = place ? cardOf(place.row, anchor, all) : cardOf(anchor.parentElement || anchor, anchor, all);
      if (cfg.skipNative && hasNative(scope)) return;

      const badge = makeBadge();
      const entry = { row: null, probe: null, badge: badge, scope: scope, w: 0, wrapSet: false, prevWrap: '' };

      if (place) {
        entry.row = place.row;
        entry.probe = place.probe;
        place.row.appendChild(badge);
        if (ro) ro.observe(place.row);
        fit(entry);
      } else {
        badge.classList.add('bsk-vb--block');
        anchor.insertAdjacentElement('afterend', badge);
      }
      entries.push(entry);
    };

    /* ---------------- Tarama ---------------- */
    const scan = () => {
      scanTimer = null;
      if (!cfg) return;

      /* Sayfadan kalkan ya da sonradan uygulamanın kendi rozetini alan
         yorumlar */
      entries = entries.filter((e) => {
        const alive = e.badge.isConnected && (!e.row || e.row.isConnected);
        const native = alive && cfg.skipNative && hasNative(e.scope);
        if (alive && !native) return true;
        if (native) e.badge.remove();
        if (e.row && ro) ro.unobserve(e.row);
        return false;
      });

      const anchors = findAnchors();
      anchors.forEach((a) => attach(a, anchors));
      status();
    };

    const queueScan = (delay) => {
      if (scanTimer) return;
      scanTimer = window.setTimeout(scan, delay == null ? 120 : delay);
    };

    /* Kendi eklediğimiz öğelerden gelen değişiklikler taramayı tetiklemez */
    const ownNode = (n) => n && n.nodeType === 1 && n.matches('.bsk-vb, .bsk-vb-pop');
    const insideOwn = (n) => {
      const el = n && (n.nodeType === 1 ? n : n.parentElement);
      return !!(el && el.closest('.bsk-vb, .bsk-vb-pop, .bsk-vb-marker'));
    };
    const onMutations = (records) => {
      for (let i = 0; i < records.length; i++) {
        const r = records[i];
        if (insideOwn(r.target)) continue;
        const nodes = Array.from(r.addedNodes).concat(Array.from(r.removedNodes));
        if (nodes.length && nodes.every(ownNode)) continue;
        queueScan();
        return;
      }
    };

    /* Tema düzenleyicideki işaret kutusunda kaç yoruma eklendiği */
    const status = () => {
      const el = document.querySelector('[data-bsk-vb-status]');
      if (!el) return;
      const n = entries.length;
      let msg = 'Yorumlar aranıyor…';
      if (n > 0) {
        msg = n + ' yoruma rozet eklendi.';
      } else if (Date.now() - bootTime > 6000) {
        msg = 'Bu sayfada rozet eklenecek yorum bulunamadı. Yorumu olan bir ürüne geç; yine 0 ise ayarlardaki "Gelişmiş" notuna bak.';
      }
      if (el.textContent !== msg) el.textContent = msg;
    };

    /* ----------------------------------------------------------------
       BİLGİ PENCERESİ
       Tek bir pencere, hangi rozete basıldıysa onun altında açılıyor.
       Aşağıda yer yoksa üstte. Dışarı tıklayınca, Esc ile ya da rozet
       ekrandan çıkınca kapanıyor.
       ---------------------------------------------------------------- */
    const pop = { el: null, text: null, link: null, btn: null, closeTimer: null, raf: 0 };

    const fillPop = () => {
      if (!pop.el || !cfg) return;
      pop.el.setAttribute('aria-label', cfg.badge);
      pop.text.textContent = cfg.text;
      pop.text.hidden = !cfg.text;
      if (cfg.linkUrl && cfg.linkLabel) {
        pop.link.href = cfg.linkUrl;
        pop.link.textContent = cfg.linkLabel;
        pop.link.hidden = false;
      } else {
        pop.link.removeAttribute('href');
        pop.link.textContent = '';
        pop.link.hidden = true;
      }
    };

    const ensurePop = () => {
      if (pop.el && pop.el.isConnected) return;
      const el = document.createElement('div');
      el.className = 'bsk-vb-pop';
      el.id = 'BskVerifiedPop';
      el.setAttribute('role', 'dialog');
      el.setAttribute('tabindex', '-1');
      el.hidden = true;

      const p = document.createElement('p');
      p.className = 'bsk-vb-pop__text';
      const a = document.createElement('a');
      a.className = 'bsk-vb-pop__link';
      el.appendChild(p);
      el.appendChild(a);
      document.body.appendChild(el);

      pop.el = el;
      pop.text = p;
      pop.link = a;

      el.addEventListener('keydown', (event) => {
        if (event.key === 'Escape') {
          event.stopPropagation();
          closePop(true);
        }
      });
      /* Klavye odağı pencereden ve rozetten çıkınca kapan */
      el.addEventListener('focusout', (event) => {
        const to = event.relatedTarget;
        if (to && !el.contains(to) && to !== pop.btn) closePop(false);
      });
      fillPop();
    };

    const place = () => {
      const btn = pop.btn;
      if (!btn || !pop.el) return;
      if (!btn.isConnected) {
        closePop(false);
        return;
      }
      const anchor = btn.closest('.bsk-vb__pill') || btn;
      const r = anchor.getBoundingClientRect();
      const vw = document.documentElement.clientWidth || window.innerWidth;
      const vh = window.innerHeight;
      if (r.bottom < 0 || r.top > vh || (!r.width && !r.height)) {
        closePop(false);
        return;
      }
      const el = pop.el;
      const pw = el.offsetWidth;
      const ph = el.offsetHeight;
      const m = 12;
      const gap = 10;

      /* Rozet ekranın sağ yarısındaysa pencerenin sağ kenarı rozetin sağ
         kenarıyla, sol yarısındaysa sol kenarlar hizalanır */
      let left = (r.left + r.width / 2 > vw / 2) ? r.right - pw : r.left;
      left = Math.max(m, Math.min(left, vw - pw - m));

      let top = r.bottom + gap;
      if (top + ph > vh - m && r.top - gap - ph >= m) top = r.top - gap - ph;

      el.style.left = Math.round(left) + 'px';
      el.style.top = Math.round(top) + 'px';
    };

    const queuePlace = () => {
      if (pop.raf) return;
      pop.raf = window.requestAnimationFrame(() => {
        pop.raf = 0;
        place();
      });
    };

    const onDocClick = (event) => {
      if (!pop.btn || !pop.el) return;
      const t = event.target;
      if (pop.el.contains(t)) return;
      const pill = pop.btn.closest('.bsk-vb__pill');
      if (pill && pill.contains(t)) return; /* rozetin kendi tıklaması aç/kapa yapıyor */
      closePop(false);
    };

    const onDocKey = (event) => {
      if (event.key === 'Escape') closePop(true);
    };

    const bindOpen = () => {
      document.addEventListener('click', onDocClick, true);
      document.addEventListener('keydown', onDocKey);
      window.addEventListener('scroll', queuePlace, { passive: true, capture: true });
      window.addEventListener('resize', queuePlace);
    };

    const unbindOpen = () => {
      document.removeEventListener('click', onDocClick, true);
      document.removeEventListener('keydown', onDocKey);
      window.removeEventListener('scroll', queuePlace, { capture: true });
      window.removeEventListener('resize', queuePlace);
    };

    const openPop = (btn) => {
      ensurePop();
      if (pop.btn && pop.btn !== btn) pop.btn.setAttribute('aria-expanded', 'false');
      const wasOpen = !!pop.btn;
      pop.btn = btn;
      btn.setAttribute('aria-expanded', 'true');
      window.clearTimeout(pop.closeTimer);

      /* Yazı tipi ve rengi rozetten: yorum alanıyla aynı görünsün */
      const cs = window.getComputedStyle(btn.closest('.bsk-vb') || btn);
      pop.el.style.fontFamily = cs.fontFamily;
      pop.el.style.color = cs.color;

      pop.el.hidden = false;
      place();
      window.requestAnimationFrame(() => {
        if (pop.btn) pop.el.classList.add('is-open');
      });
      if (!wasOpen) bindOpen();
      pop.el.focus({ preventScroll: true });
    };

    const closePop = (returnFocus) => {
      if (!pop.el || !pop.btn) return;
      const btn = pop.btn;
      pop.btn = null;
      btn.setAttribute('aria-expanded', 'false');
      pop.el.classList.remove('is-open');
      unbindOpen();
      pop.closeTimer = window.setTimeout(() => {
        if (!pop.btn && pop.el) pop.el.hidden = true;
      }, reduceMotion ? 0 : 160);
      if (returnFocus && btn.isConnected) btn.focus({ preventScroll: true });
    };

    /* ---------------- Başlat / kapat ---------------- */
    const teardown = () => {
      closePop(false);
      entries.forEach((e) => {
        e.badge.remove();
        if (e.row && e.wrapSet) e.row.style.flexWrap = e.prevWrap;
        if (e.row && ro) ro.unobserve(e.row);
      });
      entries = [];
      done = new WeakSet();
      if (pop.el) {
        pop.el.remove();
        pop.el = null;
      }
      if (mo) {
        mo.disconnect();
        mo = null;
      }
      window.clearTimeout(scanTimer);
      window.clearTimeout(statusTimer);
      scanTimer = null;
    };

    const boot = () => {
      const next = readCfg();
      if (!next) {
        if (cfg) teardown();
        cfg = null;
        cfgKey = '';
        return;
      }
      const key = JSON.stringify(next);
      if (key !== cfgKey) {
        /* İlk açılış ya da ayarlar değişti: rozetleri yeni yazıyla kur */
        if (cfg) teardown();
        cfg = next;
        cfgKey = key;
        bootTime = Date.now();
        statusTimer = window.setTimeout(() => queueScan(0), 6500);
      }
      if (!mo && document.body) {
        mo = new MutationObserver(onMutations);
        mo.observe(document.body, { childList: true, subtree: true });
      }
      queueScan(0);
    };

    const start = () => {
      boot();
      document.addEventListener('shopify:section:load', () => window.setTimeout(boot, 0));
      document.addEventListener('shopify:section:unload', () => window.setTimeout(boot, 60));
      window.addEventListener('load', refitAll);
      if (document.fonts && document.fonts.ready) {
        document.fonts.ready.then(refitAll).catch(() => {});
      }
    };

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', start);
    } else {
      start();
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["bsk-search"] && !Shopify.designMode) return;
  try {
    
  if (!window.customElements.get('bsk-search-panel')) {
    const FOCUSABLE = 'a[href], button:not([disabled]), input:not([type="hidden"]), select, textarea, [tabindex]:not([tabindex="-1"])';
    let activePanel = null;

    const esc = (value) => String(value === null || value === undefined ? '' : value)
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;')
      .replace(/'/g, '&#39;');

    /* Yazılan kısım sade, eşleşen kısım kalın. Türkçe küçük harf
       kuralıyla karşılaştırılıyor: "İ"/"I" uzunluğu bozulmuyor. */
    const highlight = (text, query) => {
      const t = String(text || '');
      const i = t.toLocaleLowerCase('tr').indexOf(query.toLocaleLowerCase('tr'));
      if (i === -1 || !query) return esc(t);
      return esc(t.slice(0, i)) + '<mark>' + esc(t.slice(i, i + query.length)) + '</mark>' + esc(t.slice(i + query.length));
    };

    /* Tahminli arama fiyatı bazen kuruş sayısı, bazen "1123.75" metni */
    const toCents = (raw) => {
      if (raw === null || raw === undefined || raw === '') return null;
      if (typeof raw === 'number') return Math.round(raw);
      const s = String(raw).trim();
      if (/^\d+$/.test(s)) return parseInt(s, 10);
      const num = parseFloat(s.replace(/[^\d.,]/g, '').replace(/\.(?=\d{3}(\D|$))/g, '').replace(',', '.'));
      return isNaN(num) ? null : Math.round(num * 100);
    };

    /* Header ve ürün bölümüyle aynı biçim: 2.690,00 TL */
    const money = (cents) => {
      if (cents === null || isNaN(cents)) return '';
      if (typeof window.bskMoney === 'function') return window.bskMoney(cents, 'TL');
      try {
        return new Intl.NumberFormat('tr-TR', { minimumFractionDigits: 2, maximumFractionDigits: 2 }).format(cents / 100) + ' TL';
      } catch (e) {
        return (cents / 100).toFixed(2) + ' TL';
      }
    };

    const imgUrl = (url, width) => url ? url + (url.indexOf('?') === -1 ? '?' : '&') + 'width=' + width : '';

    /* Header'daki arama ikonunu bu katmana bağla. Yakalama aşamasında
       dinlendiği için ikonun kendi dinleyicisine (eski arama) hiç
       ulaşılmıyor. Bölüm kaldırılınca activePanel boşalır ve eski
       arama kendiliğinden yine çalışır. */
    document.addEventListener('click', (event) => {
      if (!activePanel || !activePanel.isConnected) return;
      const trigger = event.target.closest && event.target.closest('[data-search-open]');
      if (!trigger || activePanel.overlay.contains(trigger)) return;
      event.preventDefault();
      event.stopPropagation();
      activePanel.open(trigger);
    }, true);

    /* Başka bölümler de açabilsin: document.dispatchEvent(new CustomEvent('bsk:search:open', { detail: { query: 'bluz' } })) */
    document.addEventListener('bsk:search:open', (event) => {
      if (activePanel) activePanel.open(null, event.detail && event.detail.query);
    });

    class BskSearchPanel extends HTMLElement {
      connectedCallback() {
        this.overlay = this.querySelector('[data-bsks]');
        if (!this.overlay) return;

        this.dialog = this.overlay.querySelector('.bsks__dialog');
        this.input = this.overlay.querySelector('[data-bsks-input]');
        this.results = this.overlay.querySelector('[data-bsks-results]');
        this.terms = (this.dataset.terms || '').split(',').map((s) => s.trim()).filter(Boolean);
        this.cache = new Map();
        this.reqId = 0;
        this.isOpen = false;

        /* Temanın sarmalayıcısı fixed'i kırpmasın diye body'ye */
        if (this.overlay.parentElement !== document.body) document.body.appendChild(this.overlay);

        this.formatPrices(this.overlay);
        this.bind();
        activePanel = this;

        document.querySelectorAll('[data-search-open]').forEach((btn) => {
          btn.setAttribute('aria-controls', this.overlay.id);
        });

        /* Tema düzenleyicide bölüm seçilince katman açılsın */
        this.onSelect = (e) => { if (e.detail && e.detail.sectionId === this.dataset.sectionId) this.open(); };
        this.onDeselect = (e) => { if (e.detail && e.detail.sectionId === this.dataset.sectionId) this.close(true); };
        document.addEventListener('shopify:section:select', this.onSelect);
        document.addEventListener('shopify:section:deselect', this.onDeselect);
      }

      disconnectedCallback() {
        this.stopTyper();
        if (this.ctrl) this.ctrl.abort();
        document.removeEventListener('keydown', this.onKeydown);
        document.removeEventListener('shopify:section:select', this.onSelect);
        document.removeEventListener('shopify:section:deselect', this.onDeselect);
        document.documentElement.classList.remove('bsks-lock');
        document.body.classList.remove('bsks-lock');
        if (this.overlay && this.overlay.parentElement === document.body) this.overlay.remove();
        if (activePanel === this) activePanel = null;
      }

      bind() {
        this.overlay.querySelectorAll('[data-bsks-close]').forEach((el) => {
          el.addEventListener('click', () => this.close());
        });

        this.onKeydown = (event) => {
          if (!this.isOpen) return;
          if (event.key === 'Escape') {
            event.preventDefault();
            this.close();
          } else if (event.key === 'Tab') {
            this.trapFocus(event);
          }
        };
        document.addEventListener('keydown', this.onKeydown);

        this.input.addEventListener('input', () => {
          window.clearTimeout(this.debounce);
          const q = this.input.value.trim();
          if (q.length < 2) {
            this.reqId += 1;
            if (this.ctrl) this.ctrl.abort();
            this.overlay.classList.remove('is-querying', 'is-loading');
            this.results.innerHTML = '';
            return;
          }
          this.overlay.classList.add('is-querying');
          if (!this.results.firstElementChild) this.renderSkeleton();
          this.debounce = window.setTimeout(() => this.fetchResults(q), 200);
        });
      }

      open(trigger, query) {
        if (this.isOpen) return;
        this.isOpen = true;
        this.trigger = trigger || document.activeElement;
        this.overlay.hidden = false;
        document.documentElement.classList.add('bsks-lock');
        document.body.classList.add('bsks-lock');
        window.requestAnimationFrame(() => this.overlay.classList.add('is-open'));
        document.querySelectorAll('[data-search-open]').forEach((b) => b.setAttribute('aria-expanded', 'true'));

        if (query) {
          this.input.value = query;
          this.input.dispatchEvent(new Event('input'));
        }

        /* Tıklamayla aynı karede odaklanınca iOS klavyeyi açıyor */
        this.input.focus({ preventScroll: true });
        this.startTyper();
      }

      close(silent) {
        if (!this.isOpen) return;
        this.isOpen = false;
        this.overlay.classList.remove('is-open');
        document.documentElement.classList.remove('bsks-lock');
        document.body.classList.remove('bsks-lock');
        document.querySelectorAll('[data-search-open]').forEach((b) => b.setAttribute('aria-expanded', 'false'));
        this.stopTyper();

        window.setTimeout(() => { if (!this.isOpen) this.overlay.hidden = true; }, 220);

        if (!silent && this.trigger && this.trigger.focus && document.contains(this.trigger)) {
          this.trigger.focus({ preventScroll: true });
        }
      }

      trapFocus(event) {
        const nodes = Array.from(this.dialog.querySelectorAll(FOCUSABLE)).filter((el) => el.offsetParent !== null);
        if (nodes.length === 0) return;
        const first = nodes[0];
        const last = nodes[nodes.length - 1];
        if (!this.dialog.contains(document.activeElement)) {
          event.preventDefault();
          first.focus();
        } else if (event.shiftKey && document.activeElement === first) {
          event.preventDefault();
          last.focus();
        } else if (!event.shiftKey && document.activeElement === last) {
          event.preventDefault();
          first.focus();
        }
      }

      /* ---------- Kutuda yazılıp silinen örnek kelimeler ----------
         Yalnızca katman açık ve kutu boşken çalışır. Hareket azaltma
         açıksa ilk kelime sabit durur. */
      startTyper() {
        this.stopTyper();
        if (this.terms.length === 0) return;
        if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
          this.input.placeholder = this.terms[0];
          return;
        }

        let word = 0;
        let chars = 0;
        let deleting = false;

        const tick = () => {
          if (!this.isOpen) return;
          if (this.input.value) {
            this.input.placeholder = '';
            this.typer = window.setTimeout(tick, 400);
            return;
          }
          const text = this.terms[word];
          if (!deleting) {
            chars += 1;
            this.input.placeholder = text.slice(0, chars);
            if (chars >= text.length) {
              deleting = true;
              this.typer = window.setTimeout(tick, 1600);
              return;
            }
            this.typer = window.setTimeout(tick, 95);
          } else {
            chars -= 1;
            this.input.placeholder = text.slice(0, chars);
            if (chars <= 0) {
              deleting = false;
              word = (word + 1) % this.terms.length;
              this.typer = window.setTimeout(tick, 380);
              return;
            }
            this.typer = window.setTimeout(tick, 45);
          }
        };

        this.input.placeholder = '';
        this.typer = window.setTimeout(tick, 250);
      }

      stopTyper() {
        window.clearTimeout(this.typer);
        if (this.input && this.terms && this.terms.length) this.input.placeholder = this.terms[0];
      }

      formatPrices(root) {
        root.querySelectorAll('[data-cents]').forEach((el) => {
          const value = money(toCents(el.dataset.cents));
          if (value) el.textContent = value;
        });
      }

      /* ---------- Anlık sonuçlar ---------- */
      async fetchResults(query) {
        const key = query.toLocaleLowerCase('tr');
        const id = ++this.reqId;

        if (this.cache.has(key)) {
          this.render(this.cache.get(key), query);
          return;
        }

        if (this.ctrl) this.ctrl.abort();
        this.ctrl = new AbortController();
        this.overlay.classList.add('is-loading');

        /* Shopify tahminli arama uç noktası .json ile çağrılmalı */
        let url = this.dataset.predictiveUrl || '/search/suggest';
        if (url.indexOf('.json') === -1) url += '.json';

        const params = new URLSearchParams();
        params.set('q', query);
        params.set('resources[type]', 'query,product,collection');
        params.set('resources[limit]', this.dataset.limit || '8');
        params.set('resources[options][unavailable_products]', 'last');
        params.set('resources[options][fields]', 'title,product_type,variants.title,vendor,tag');

        try {
          const response = await fetch(url + '?' + params.toString(), {
            headers: { Accept: 'application/json' },
            signal: this.ctrl.signal
          });
          if (!response.ok) throw new Error('HTTP ' + response.status);
          const data = await response.json();
          this.cache.set(key, data);
          if (id === this.reqId) this.render(data, query);
        } catch (e) {
          if (e.name === 'AbortError' || id !== this.reqId) return;
          this.results.innerHTML =
            '<p class="bsks__empty">Öneriler yüklenemedi. Enter\'a basarak tüm sitede arayabilirsin.</p>';
        } finally {
          if (id === this.reqId) this.overlay.classList.remove('is-loading');
        }
      }

      renderSkeleton() {
        const chips = '<span class="bsks__sk bsks__sk--chip"></span>'.repeat(4);
        const cards = '<li><span class="bsks__sk bsks__media"></span><span class="bsks__sk bsks__sk--line"></span></li>'.repeat(4);
        this.results.innerHTML =
          '<div class="bsks__block"><div class="bsks__chips">' + chips + '</div></div>' +
          '<ul class="bsks__grid" aria-hidden="true">' + cards + '</ul>';
      }

      render(data, query) {
        const found = (data.resources && data.resources.results) || {};
        const products = found.products || [];
        const queries = found.queries || [];
        const collections = found.collections || [];
        const searchUrl = (this.dataset.searchUrl || '/search') + '?q=' + encodeURIComponent(query) + '&type=product';

        if (products.length === 0 && queries.length === 0 && collections.length === 0) {
          this.results.innerHTML =
            '<p class="bsks__empty">“' + esc(query) + '” ile eşleşen ürün yok. Daha kısa bir kelime dene ya da popüler aramalardan birini seç.</p>' +
            '<a class="bsks__all" href="' + esc(searchUrl) + '">Tüm sitede ara</a>';
          return;
        }

        let html = '';

        if (queries.length > 0) {
          html += '<div class="bsks__block"><p class="bsks__label">Öneriler</p><ul class="bsks__chips">';
          html += queries.map((item) =>
            '<li><a class="bsks__chip" href="' + esc(item.url) + '">' + highlight(item.text, query) + '</a></li>'
          ).join('');
          html += '</ul></div>';
        }

        if (collections.length > 0) {
          html += '<div class="bsks__block"><p class="bsks__label">Kategoriler</p><ul class="bsks__chips">';
          html += collections.map((item) =>
            '<li><a class="bsks__chip" href="' + esc(item.url) + '">' + highlight(item.title, query) + '</a></li>'
          ).join('');
          html += '</ul></div>';
        }

        if (products.length > 0) {
          html += '<div class="bsks__block"><p class="bsks__label">Ürünler</p><ul class="bsks__grid">';
          html += products.map((p) => {
            const src = p.featured_image && p.featured_image.url ? p.featured_image.url : (p.image || '');
            const img = src
              ? '<img src="' + esc(imgUrl(src, 600)) + '" srcset="' + esc(imgUrl(src, 360)) + ' 360w, ' + esc(imgUrl(src, 600)) + ' 600w" sizes="(min-width: 768px) 25vw, 50vw" alt="" loading="lazy" decoding="async">'
              : '';
            const price = money(toCents(p.price !== undefined && p.price !== null ? p.price : p.price_min));
            const compareCents = toCents(p.compare_at_price_max || p.compare_at_price);
            const priceCents = toCents(p.price !== undefined && p.price !== null ? p.price : p.price_min);
            const old = compareCents && priceCents && compareCents > priceCents ? '<s>' + money(compareCents) + '</s>' : '';

            return '<li><a class="bsks__card" href="' + esc(p.url) + '">' +
              '<span class="bsks__media">' + img + '</span>' +
              '<span class="bsks__card-title">' + esc(p.title) + '</span>' +
              (price ? '<span class="bsks__card-price">' + old + '<span>' + price + '</span></span>' : '') +
            '</a></li>';
          }).join('');
          html += '</ul></div>';
        }

        html += '<a class="bsks__all" href="' + esc(searchUrl) + '">Tüm sonuçları gör</a>';
        this.results.innerHTML = html;
      }
    }

    window.customElements.define('bsk-search-panel', BskSearchPanel);
  }

  } catch(e) { console.error(e); }
})();
})();
